<template>
    <div class="apaympro-container">
        
        <!-- Loader -->
        <loading :active.sync="isLoading" :can-cancel="false" :on-cancel="onCancel"
            :is-full-page="fullPage" loader="bars" :opacity="1"
        ></loading>

        <!-- Return to search for a merchant -->
        <router-link style=" position: absolute; left: 25px; margin-top: 15px; margin-bottom: 10px; width: 100px; z-index: 100; cursor: pointer; font-size: 20px;"
            class="element-wrap element-wrap-on-left" to="/"
        >
            <i class="fas fa-home"></i>
        </router-link>

        <!-- Top Bar Component --> 
        <top-bar></top-bar> 
        <!-- Top Bar Component -->

        <!-- ****************************** ---->
        <!-- ****************************** ---->
        <!----- Formulaire d'achat de carte ---->
        <!-- ****************************** ---->
        <!-- ****************************** ---->


        <!-- ********************* -->
        <!-- ********************* -->
        <!-- Choix des cartes Visa -->
        <!-- ********************* -->
        <!-- ********************* -->
        <choix-cartes :checkCard="checkCard" :cartesChoisis="cartesChoisis" :validerCartes="validerCartes"
                :listeCartes="listeCartes" :choisirCarte="choisirCarte" :voirDetails="voirDetails">
        </choix-cartes>
        <!-- ********************* -->
        <!-- ********************* -->
        <!-- Choix des cartes Visa -->
        <!-- ********************* -->
        <!-- ********************* -->


        <div class="apaympro-wrapper animated fadeIn container"  style="width: 650px;" v-if="!checkCard">
            <div class="apaympro-page">

                <!-- Header -->
                <div class="apaympro-header mb-3">
                    <div class="page-info pos-relative2">
                        <h3 class="page-name mb-2" style="font-weight: 800; font-size: 1.6rem;">
                            Achat de cartes Visa
                        </h3>

                        <div class="line2 mt-4">

                            <!-- Les cartes commandées -->
                            <span class="text-muted">
                                <strong class="font-14">COMMANDES</strong>
                            </span>

                            <div class="demo-badge-list">
                                <span
                                     class="badge badge-pill badge-light mt-2 mr-2"
                                     v-for="carte in cartesChoisis" :key="carte.id"
                                     style="background: #dfe2e5; color: #271c65;"
                                >
                                    <span style="cursor: pointer;" v-b-tooltip.hover :title=" new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( carte.montant ) ">
                                        {{ carte.carte }}
                                    </span>
                                    <i
                                         class="ml-3 fas fa-times" v-if=" cartesChoisis.length > 1 && hideRecu == true && !showFormPaiement"
                                         style="cursor: pointer; color: #6c757d;" v-b-tooltip.hover
                                         title="Retirer la carte" @click="removeCarteFromListe(carte)"
                                    ></i>
                                </span>

                            </div>

                            <!-- Les cartes commandées -->

                            <span class="text-muted">
                                <br>
                                <strong class="font-14">TOTAL</strong>
                            </span>

                            <h3 class="text-primary mb-3" style="font-weight: bold; margin: 0 auto;">
                                {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}
                            </h3>

                            <!--<span class="text-muted">
                                <strong style="font-size: 16px !important;">
                                    Frais
                                    <i style="font-style: normal; color: #261b64 !important; font-weight: bold;">
                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( frais ) }}
                                    </i> inclus
                                </strong>
                            </span>-->

                        </div>
                    </div>
                </div>
                <!-- Header -->

                <!-- Body -->
                <!-- ******************* -->
                <!-- Informations payeur -->
                <!-- ******************* -->
                <div class="body mt-5">
                    
                    <!-- ********************** -->
                    <!-- Les différentes étapes -->
                    <!-- ********************** -->
                    <etapes-commande :showFormInformations="showFormInformations" :showFormIdentification="showFormIdentification"
                            :showFormPaiement="showFormPaiement" :showContent="showContent">
                    </etapes-commande>
                    <!-- ********************** -->
                    <!-- Les différentes étapes -->
                    <!-- ********************** -->

                    <!-- ************ -->
                    <!-- Informations -->
                    <!-- ************ -->
                    <form-informations :value="formInformations" :value2="indice" :showFormInformations="showFormInformations"
                          :validerCartes="validerCartes" :formIdentificationNext="formIdentificationNext" :pays="pays">
                    </form-informations>
                    <!-- ************ -->
                    <!-- Informations -->
                    <!-- ************ -->

                    <!-- ************** -->
                    <!-- Identification -->
                    <!-- ************** -->
                    <form-identification :showFormIdentification="showFormIdentification" :value="formIdentification"
                          :formInfosReturn="formInfosReturn" :formPaiementNext="formPaiementNext">
                    </form-identification>
                    <!-- ************** -->
                    <!-- Identification -->
                    <!-- ************** -->


                    <!-- ******** -->
                    <!-- Paiement -->
                    <!-- ******** -->
                    <form class="payment-form" v-if=" showFormPaiement ">
                        <div style="display: flex; justify-content: center;">
                            <div class="custom-width2">
                                <div class="row mt-2">

                                    <!-- Cash en agence -->
                                    <!--<div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('cash')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'cash'"
                                        >
                                        <img src="../assets/img/menu/cash.png" alt="Logo" :class="mode_paiement == 'cash' ? 'mode-selected' : ''">
                                    </div>-->
                                    <!-- Cash en agence -->

                                    <!-- Visa -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('VISA')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'VISA'"
                                        >
                                        <img src="../assets/img/menu/visa.png" alt="Logo" :class="mode_paiement == 'VISA' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- Visa -->

                                    <!-- Mastercard -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('MASTERCARD')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'MASTERCARD'"
                                        >
                                        <img src="../assets/img/menu/mastercard.png" alt="Logo" :class="mode_paiement == 'MASTERCARD' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- Mastercard -->
                                    
                                    <!-- Orange Money -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('Orange Money')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'Orange Money'"
                                        >
                                        <img src="../assets/img/menu/om.png" alt="Logo" :class="mode_paiement == 'Orange Money' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- Orange Money -->

                                    <!-- Wave -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('Wave')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'Wave'"
                                        >
                                        <img src="../assets/img/menu/wave.png" alt="Logo" :class="mode_paiement == 'Wave' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- Wave -->

                                    <!-- MTN Money -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('MTN Money')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'MTN Money'"
                                        >
                                        <img src="../assets/img/menu/momo.png" alt="Logo" :class="mode_paiement == 'MTN Money' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- MTN Money -->

                                    <!-- Moov Money -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('Moov Money')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'Moov Money'"
                                        >
                                        <img src="../assets/img/menu/flooz.png" alt="Logo" :class="mode_paiement == 'Moov Money' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- Moov Money -->

                                    <!-- APaym UUSD -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('APaym USSD')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32" class="show-selected-mode2" v-if="mode_paiement == 'APaym USSD'">
                                        <img src="../assets/img/menu/apaym-ussd.png" alt="Logo" :class="mode_paiement == 'APaym USSD' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- APaym UUSD -->

                                    <!-- APaym -->
                                    <div class="col-4 mb-4 custom-col mode-rechargement" @click="selectModePaiement('APaym')">
                                        <img src="../assets/img/badge-check.png" alt="badge checked" width="32"
                                            class="show-selected-mode2" v-if="mode_paiement == 'APaym'"
                                        >
                                        <img src="../assets/img/menu/apaym.png" alt="Logo" :class="mode_paiement == 'APaym' ? 'mode-selected' : ''">
                                    </div>
                                    <!-- APaym -->

                                </div>
                            </div>
                        </div>

                        <!-- Boutons -->
                        <div class="mt-5" style="display: flex; justify-content: center; align-items: center;">

                            <button type="button" :disabled="!mode_paiement" @click="validerModePaiement"
                                :class=" !mode_paiement ? 'btn btn-sm btn-dark btn-disabled-custom font-14' : 'btn btn-sm btn-dark font-14' "
                                style="font-weight: bold;"
                            >
                                Valider le mode de paiement
                                
                            </button>

                        </div>
                        <!-- Boutons -->
                    </form>
                    <!-- ******** -->
                    <!-- Paiement -->
                    <!-- ******** -->


                    <!-- ********************* -->
                    <!-- Les modes de paiement -->
                    <!-- ********************* -->
                    <form class="payment-form" v-if=" showContent " style="display: flex; flex-direction: column; align-items: center;">

                        <div class="mb-2">

                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Change Menu -->
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <div style="display: flex; flex-direction: row; z-index: 1; align-items: center; width: 100%; padding: 13px; justify-content: center; background: #f4f4f4; border-radius: 10px; margin-bottom: 3rem;" v-if="showContent">
                                <div style="display: flex; flex-direction: row; z-index: 1; align-items: center; width: 100%; justify-content: space-between;">
                                    <span class="font-17" style="font-weight: 800;">
                                        {{ mode_paiement }}
                                    </span>
                                    <a href="javascript:;" style="color: #0e2abd; font-weight: 600;" @click="changerMenu">
                                        <i class="fas fa-exchange-alt" style="transform: rotate(-60deg);"></i> Changer
                                    </a>
                                </div>
                            </div>
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Change Menu -->
                            <!-- **************************** -->
                            <!-- **************************** -->

                            <!-- VISA or MASTERCARD Button -->
                            <div class="element-wrap element-wrap-for-submit" v-if="mode_paiement == 'MASTERCARD' || mode_paiement == 'VISA'">

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length > 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de vos {{ cartesChoisis.length }} cartes
                                </h4>

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length == 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de votre carte
                                </h4>

                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->
                                <!-- BICICI No Okay -->
                                <div class="displayerror__details mt-3" v-if="biciciNOkay">
                                    <div>
                                        <p class="paiement-failed">
                                            Paiement {{ mode_paiement }} échoué ou annulé
                                        </p>
                                        <div class="error-information" >
                                            Votre paiement via {{ mode_paiement }} a echoué ou a été annulé !
                                            <br>
                                            Veuillez essayer un autre mode de paiement.
                                        </div>
                                    </div>
                                </div>
                                <!-- BICICI No Okay -->
                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->

                                <!--<button type="button" @click="sendBicici" class="btn btn-dark btn-block" >
                                    Payer par {{ mode_paiement }}
                                </button>-->
                                <button type="button" @click="sendCardPaymentUba" class="btn btn-dark btn-block" >
                                    Payer par {{ mode_paiement }}
                                </button>


                            </div>
                            <!-- VISA or MASTERCARD Button -->
                        
                            <!-- Orange Money Button -->
                            <div class="text-center" v-if=" mode_paiement == 'Orange Money' ">

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length > 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de vos {{ cartesChoisis.length }} cartes
                                </h4>

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length == 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de votre carte
                                </h4>

                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->
                                <!-- Orange No Okay -->
                                <div class="displayerror__details mb-4 font-14" v-if="orangeNOkay">
                                    <div class="text-center">
                                        <p class="paiement-failed">
                                            Paiement via Orange échoué ou annulé
                                        </p>
                                        <div class="error-information">
                                            Votre paiement via {{ mode_paiement }} a echoué ou a été annulé ! 
                                            <br>
                                            Veuillez essayer un autre mode de paiement.
                                        </div>
                                    </div>
                                </div>
                                <!-- Orange No Okay -->
                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->

                                <div class="mb-4 font-14" v-if="mobileDevice">
                                    <p class="paiement-failed" style="font-weight: 600;color: #261b64;">
                                        Assurez-vous d'avoir la dernière version de l'application Orange Money installée sur votre téléphone !
                                    </p>
                                </div>

                                <button v-if="mobileDevice" type="button"
                                    @click="sendOM('app')"
                                    class="btn btn-dark mb-3"
                                >
                                    Payer avec l'Appli Orange Money
                                </button>

                                <span class="text-dark mt-5 mb-5" style="font-weight: 900" v-if="mobileDevice">
                                    OU
                                </span>

                                <button type="button" @click="sendOM('ussd')"
                                    :class="mobileDevice ? 'btn btn-outline-dark mt-3' : 'btn btn-dark mt-3'"
                                >
                                    Payer par code Orange Money
                                </button>

                            </div>
                            <!-- Orange Money Button -->

                            <!-- Wave Button -->
                            <div class="element-wrap element-wrap-for-submit" v-if="mode_paiement == 'Wave'">

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length > 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de vos {{ cartesChoisis.length }} cartes
                                </h4>

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length == 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de votre carte
                                </h4>

                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->
                                <!-- Wave No Okay -->
                                <div class="displayerror__details mb-4 font-14" v-if="waveNOkay">
                                    <div class="text-center">
                                        <p class="paiement-failed">
                                            Paiement Wave échoué ou annulé
                                        </p>
                                        <div class="error-information">
                                            Votre paiement via {{ mode_paiement }} a echoué ou a été annulé ! 
                                            <br>
                                            Veuillez essayer un autre mode de paiement.
                                        </div>
                                    </div>
                                </div>
                                <!-- Wave No Okay -->
                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->

                                <div class="mb-4 font-14" v-if="mobileDevice">
                                    <p class="paiement-failed" style="font-weight: 600;color: #261b64;">
                                        Assurez-vous d'avoir la dernière version de l'application installée sur votre téléphone !
                                    </p>
                                </div>

                                <button v-if="mobileDevice" type="button" @click="sendWave('app')" class="btn btn-dark btn-block mb-3">
                                    Payer avec l'App Wave
                                </button>

                                <span class="text-dark mt-5 mb-5" style="font-weight: 900" v-if="mobileDevice">
                                    OU
                                </span>

                                <button type="button" @click="sendWave('normal')"
                                    :class="mobileDevice ? 'btn btn-outline-dark btn-block mt-3' : 'btn btn-dark btn-block mt-3'"
                                >
                                    Payer par Wave
                                </button>

                            </div>
                            <!-- Wave Button -->

                            <!-- MTN Money Button -->
                            <div class="element-wrap element-wrap-for-submit" v-if="mode_paiement == 'MTN Money'">

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length > 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de vos {{ cartesChoisis.length }} cartes
                                </h4>

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length == 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de votre carte
                                </h4>

                                <div v-if="mtnOkay" class="displayerror__details mt-3" style="padding: 10px 5px 2px 5px;" >
                                    <div class="qr__code mt-2">
                                        <i
                                            class="fas fa-spinner fa-spin"
                                            style="font-size: 20px;"
                                        ></i>
                                    </div>   
                                    <div class="mt-2">
                                        <p
                                            class="paiement-failed"
                                            style="font-weight: 600;color: #261b64;"
                                        >
                                            En attente de validation
                                        </p>
                                    </div>
                                </div>

                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->
                                <!-- MTN No Okay -->
                                <div class="displayerror__details mt-3" v-if="mtnNOkay" >
                                    <div class="text-center">
                                        <p class="paiement-failed">
                                            Paiement MTN échoué ou annulé
                                        </p>
                                        <div
                                            class="error-information"
                                        >
                                            Votre paiement via {{ mode_paiement }} a echoué ou a été annulé ! 
                                            <br>
                                            Veuillez essayer un autre mode de paiement.
                                        </div>
                                    </div>
                                </div>
                                <!-- MTN No Okay -->
                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->

                                <!-- Numero -->
                                <div class="element-pair-container">
                                    <div class="element-wrap element-wrap-on-left">
                                        <multiselect
                                            v-model="indiceMobileMoney"
                                            :options="options"
                                            :multiple="false"
                                            placeholder="Indicatif"
                                            tag-placeholder="Indicatif"
                                            track-by="code"
                                            label="country"
                                            :searchable="true"
                                            disabled
                                        >
                                            <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                            <span slot="noResult"></span>
                                        </multiselect>
                                    </div>
                                    <div class="element-wrap element-wrap-on-right"> 
                                        <input
                                            type="text"
                                            placeholder="Numéro MTN Money"
                                            class="element-is-input"
                                            v-model="dataMoMo.numero"
                                            v-mask="'## ## ## ## ##'"
                                        />
                                    </div>
                                </div>
                                <!-- Numero -->


                                <button type="button" @click="sendMoMo" :disabled="!dataMoMo.numero || mtnOkay"
                                    :class="!dataMoMo.numero || mtnOkay ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                >
                                    Payer par MoMo
                                </button>
                            </div>
                            <!-- MTN Money Button -->

                            <!-- Moov Money Button -->
                            <div class="element-wrap element-wrap-for-submit" v-if="mode_paiement == 'Moov Money'">

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length > 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de vos {{ cartesChoisis.length }} cartes
                                </h4>

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length == 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>{{ mode_paiement }}</strong> de votre carte
                                </h4>

                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->
                                <!-- Moov No Okay -->
                                <div class="displayerror__details mt-3"
                                    v-if="moovNOkay"
                                >
                                    <div class="text-center">
                                        <p class="paiement-failed">
                                            Paiement Moov échoué ou annulé
                                        </p>
                                        <div
                                            class="error-information"
                                        >
                                            Votre paiement via {{ mode_paiement }} a echoué ou a été annulé !
                                            <br>
                                            Veuillez essayer un autre mode de paiement.
                                        </div>
                                    </div>
                                </div>
                                <!-- Moov No Okay -->
                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->

                                <!-- Timer Moov Money -->
                                <div v-if="moovOkay"
                                    class="displayerror__details mt-2"
                                    style="padding: 0 5px 2px 5px;"
                                >
                                    <div class="qr__code mt-2 pt-2" v-if="showVerifMoov">
                                        <i
                                            class="fas fa-spinner fa-spin"
                                            style="font-size: 20px;"
                                        ></i>
                                    </div>   
                                    <div class="mt-2 pt-2" v-if="!showVerifMoov && !showInProcessMoov">
                                        <p
                                            class="paiement-failed"
                                            style="font-weight: 600;"
                                        >
                                            Veuillez patienter
                                        </p>
                                    </div>
                                    <span class="timer" v-if="!showVerifMoov && !showInProcessMoov">
                                        {{ formattedTimeLeft }} min
                                    </span>
                                    <div class="mt-2" v-if="!showVerifMoov && !showInProcessMoov">
                                        <p
                                            class="paiement-failed"
                                            style="font-weight: 600;"
                                        >
                                            Avant vérification de votre transaction
                                        </p>
                                    </div>
                                    <div class="mt-2" v-if="showVerifMoov">
                                        <p
                                            class="paiement-failed"
                                            style="font-weight: 600;color: #261b64;"
                                        >
                                            En cours de vérification
                                        </p> 
                                    </div>

                                    <div class="qr__code mt-2 pt-2" v-if="showInProcessMoov">
                                        <i
                                            class="fas fa-spinner fa-spin"
                                            style="font-size: 20px;"
                                        ></i>
                                    </div> 

                                    <div class="mt-2" v-if="showInProcessMoov">
                                        <p
                                            class="paiement-failed"
                                            style="font-weight: 600;color: #261b64;"
                                        >
                                            En attente de validation
                                        </p> 
                                    </div>
                                </div>
                                <!-- Timer Moov Money -->

                                <!-- Numero Moov Money -->
                                <div class="element-pair-container">
                                    <div class="element-wrap element-wrap-on-left">
                                        <multiselect
                                            v-model="indiceMobileMoney"
                                            :options="options"
                                            :multiple="false"
                                            placeholder="Indicatif"
                                            tag-placeholder="Indicatif"
                                            track-by="code"
                                            label="country"
                                            :searchable="true"
                                            disabled
                                        >
                                            <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                            <span slot="noResult"></span>
                                        </multiselect>
                                    </div>
                                    <div class="element-wrap element-wrap-on-right"> 
                                        <input
                                            type="text"
                                            placeholder="Numéro Moov Money"
                                            class="element-is-input"
                                            v-model="dataMoov.numero"
                                            v-mask="'## ## ## ## ##'"
                                        />
                                    </div>
                                </div>
                                <!-- Numero Moov Money -->

                                <button
                                    type="button"
                                    @click="sendMoov"
                                    :class="!dataMoov.numero || moovOkay ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                    :disabled="!dataMoov.numero || moovOkay"
                                >
                                    Payer par Flooz
                                </button>
                            </div>
                            <!-- Moov Money Button -->

                            <!-- APaym USSD Button -->
                            <div class="element-wrap element-wrap-for-submit" v-if="mode_paiement == 'APaym USSD'">

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length > 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>APAYM USSD</strong> de vos {{ cartesChoisis.length }} cartes
                                </h4>

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length == 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>APAYM USSD</strong> de votre carte
                                </h4>

                                <p class="instruction mb-5"> 
                                    Pour obtenir votre code de paiement, composez le  <strong class="custom-text">*766#</strong>  
                                    sur Orange et MTN, et suivez les instructions. 
                                </p>

                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->
                                <!-- APaym No Okay -->
                                <div class="displayerror__details mt-3" v-if="apaymNOkay">
                                    <div class="text-center">
                                        <p class="paiement-failed">
                                            Paiement  échoué ou annulé
                                        </p>
                                        <div class="error-information">
                                            Votre paiement via APAYM USSD a echoué ou a été annulé !
                                            <br>
                                            Veuillez essayer un autre mode de paiement.
                                        </div>
                                    </div>
                                </div>
                                <!-- APaym No Okay -->
                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->


                                <!-- Numero APaym -->
                                <div class="element-pair-container">
                                    <div class="element-wrap element-wrap-on-left">
                                        <multiselect
                                            v-model="dataAPaym.indicatif"
                                            :options="options"
                                            :multiple="false"
                                            placeholder="Indicatif"
                                            tag-placeholder="Indicatif"
                                            track-by="code"
                                            label="country"
                                            :searchable="true"
                                        >
                                            <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                            <span slot="noResult"></span>
                                        </multiselect>
                                    </div>
                                    <div class="element-wrap element-wrap-on-right"> 
                                        <input
                                            type="text"
                                            placeholder="Numéro de tél. APaym"
                                            class="element-is-input"
                                            v-model="dataAPaym.numero"
                                            v-mask="'## ## ## ## ##'"
                                        />
                                    </div>
                                </div>
                                <!-- Numero APaym -->

                                <!-- Code de paiement -->
                                <div class="element-wrap mb-4 mt-4">
                                    <input
                                        type="text"
                                        class="element-is-input"
                                        :disabled="!dataAPaym.numero"
                                        v-model="dataAPaym.codeApaym"
                                        placeholder="Code de paiement"
                                    />
                                </div>
                                <!-- Code de paiement -->

                                <button type="button" @click="sendAPaym" :disabled="!dataAPaym.numero || apaymOkay"
                                    :class="!dataAPaym.numero || apaymOkay ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                >
                                    Payer par APAYM USSD
                                </button>
                            </div>
                            <!-- APaym USSD Button -->

                            <!-- APaym Button -->
                            <div class="element-wrap element-wrap-for-submit" v-if="mode_paiement == 'APaym'">

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length > 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>APAYM</strong> de vos {{ cartesChoisis.length }} cartes
                                </h4>

                                <h4 class="font-17 mb-5" style="font-weight: 500; line-height: 1.5;" v-if="cartesChoisis.length == 1">
                                    Vous serez débité de <strong>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}</strong>
                                    pour l'achat par <strong>APAYM</strong> de votre carte
                                </h4>

                                <div class="visa-qr-container__header">
                                    <div v-if="showCard == true">
                                        Cliquez sur l'une de vos cartes afin de valider le paiement
                                    </div>
                                    <div class="btn btn-link" v-if="showCard == true" @click="disconnectApaym"
                                        style="display: flex; align-items: center; background: none; text-align: center; justify-content: center; font-weight: 900; height: 30px;"
                                    >
                                        Déconnexion
                                    </div>
                                    <p class="instruction mt-3" v-if="loginApaym">
                                        Connectez-vous à votre compte APAYM pour afficher vos cartes Visa qui y sont rattachées. Cliquez sur la flèche pour vous connecter.
                                    </p>
                                </div>

                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->
                                <!-- APaym No Okay -->
                                <div class="displayerror__details mt-3" v-if="apaymNOkay2">
                                    <div class="text-center">
                                        <p class="paiement-failed">
                                            Paiement  échoué ou annulé
                                        </p>
                                        <div
                                                class="error-information"
                                        >
                                                Votre paiement via APAYM a echoué ou a été annulé !
                                            <br>
                                            Veuillez essayer un autre mode de paiement.
                                        </div>
                                    </div>
                                </div>
                                <!-- APaym No Okay -->
                                <!-- ************** -->
                                <!-- Échec Paiement -->
                                <!-- ************** -->

                                <!-- Numero APaym -->
                                <div class="element-pair-container" v-if="loginApaym">
                                    <div class="element-wrap element-wrap-on-left">
                                        <multiselect v-model="dataApaymPayAuth.indicatif" :options="options"
                                            :multiple="false" placeholder="Indicatif" tag-placeholder="Indicatif"
                                            track-by="code" label="country" :searchable="true"
                                        >
                                            <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                            <span slot="noResult"></span>
                                        </multiselect>
                                    </div>
                                    <div class="element-wrap element-wrap-on-right">
                                        <div
                                            style="
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                type="text"
                                                placeholder="Numéro de tél. APaym"
                                                class="element-is-input"
                                                v-model="dataApaymPayAuth.numero"
                                                v-mask="'## ## ## ## ##'"
                                            />
                                            <i
                                                class="fas fa-arrow-right searchIcon"
                                                aria-hidden="true"
                                                @click="sendAPaymAuth"
                                            ></i>
                                        </div>
                                    </div>
                                </div>
                                <!-- Numero APaym -->

                                <div class="element-wrap" v-if="hideCodePay">
                                    <input
                                        type="text"
                                        class="element-is-input"
                                        :disabled="!dataApaymPayAuth.numero"
                                        v-model="dataApaymPayAuth.code"
                                        placeholder="Renseigner le code reçu par sms"
                                    />
                                </div>

                                <button type="button" @click="sendAPaymToken" v-if="hideCodePay"
                                    :class="!dataApaymPayAuth.numero || !dataApaymPayAuth.code ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                    :disabled="!dataApaymPayAuth.numero || !dataApaymPayAuth.code"
                                >
                                    Payer par APAYM
                                </button>

                                <!-- Liste des cartes -->
                                <div v-if="showCard == true">
                                    <ul class="list-unstyled text-left"
                                        :style="cardsLength > 5 ? 'height: 392px; overflow-y: scroll;' : 'height: auto;'"
                                    >
                                        <li class="media py-3" v-for="(carte,i) in cards"
                                            :key="i" style="cursor: pointer;" @click="payWithApaym(carte)"
                                        >
                                            <div class="mr-3 position-relative">
                                                <img :src="require(`../assets/img/cards/${carte.imgCard}`)"
                                                    alt="image" width="45"
                                                />
                                            </div>
                                            <div class="media-body">
                                                <div class="d-flex justify-content-between"
                                                    style="text-align: left;"
                                                >
                                                    <div>
                                                        {{ carte.nickname }}
                                                        <br/>
                                                        <span class="font-11">
                                                            Visa **** {{ carte.last_4_digit }}
                                                            <img src="../assets/img/icons/icon-recieve_money-193.png"
                                                                 width="15" class="ml-2" v-b-tooltip
                                                                title="Carte favorite" :hidden="carte.favori_card == false"
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <!-- <div>Cliquez sur l'une de vos cartes pour effectuer le paiement</div> -->
                                </div>
                                <!-- Liste des cartes -->

                            </div>
                            <!-- APaym Button -->

                        </div> 

                    </form>
                    <!-- ********************* -->
                    <!-- Les modes de paiement -->
                    <!-- ********************* -->
                    
                </div>
                <!-- ******************* -->
                <!-- Informations payeur -->
                <!-- ******************* -->


                <!-- ******************** -->
                <!-- Reçu de pré-commande -->
                <!-- ******************** -->
                <div class="body" ref="document" hidden>
                    <!-- Entête -->
                    <table>
                        <tr>
                            <td style="width:40%;">
                                <img src="../assets/Logo-APAYM.png" width="130" alt="Logo APaym"/>
                            </td>
                            <td style="width:60%; font-size:14px; text-align:right; line-height: 1.5;">
                                RECU DE PRE-COMMANDE<br/>
                                {{ datePrecommande | formatDate }} <br>
                                Nº <strong>{{ refID }}</strong>
                            </td>
                        </tr>
                    </table>
                    <!-- Entête -->

                    <!-- Corps -->
                    <table style="margin-top: 10px; font-weight:bold; line-height: 1.7;">
	
                        <tr>
                            <td colspan="2" class="custom-td">
                                Carte(s) pré-commandée(s)
                            </td>
                        </tr>

                        <tr class="row mb-2" style="margin-right: 0px; margin-left: 0px;">
                            <td v-for="carte in cartesChoisis" style="padding:5px; padding-top:5px;" :key="carte.id" class="col-lg-6 col-xs-6 col-6 mt-2 font-14">
                                <span class="intitule"> 
                                    {{ carte.carte }}
                                </span>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2" class="custom-td">
                                Coordonnées
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
                            <td style="padding:5px; padding-top:5px;" class="col-lg-6 col-xs-6 col-6 mt-2 font-14">
                                Civilité : 
                                <span class="intitule"> 
                                    {{ formInformations.civilite }} 
                                </span>
                            </td>
                            <td style="padding:5px; padding-top:5px;" class="col-lg-6 col-xs-6 col-6 mt-2 font-14">
                                Adresse : 
                                <span class="intitule"> 
                                    {{ formInformations.adresse }} 
                                </span>
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Nom : 
                                <span class="intitule">
                                    {{ formInformations.nom }}
                                </span>
                            </td>
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Ville : 
                                <span class="intitule"> 
                                    {{ formInformations.ville }}  
                                </span>
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Prénom(s) : 
                                <span class="intitule"> 
                                    {{ formInformations.prenom }} 
                                </span>
                            </td>
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Pays : 
                                <span class="intitule"> 
                                    {{ indice.i.country }} 
                                </span>
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Date de naissance : 
                                <span class="intitule"> 
                                    {{ dateNaissance }} 
                                </span>  
                                <input type="radio" v-if="formIdentification.mineur" :checked="formIdentification.mineur ? 'checked' : ''" disabled/> <span v-if="formIdentification.mineur">Mineur</span>
                            </td>
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Type de pièce :
                                <span class="intitule"> 
                                    {{ formIdentification.typePiece }} 
                                </span>
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Nationalité : 
                                <span class="intitule"> 
                                    {{ formInformations.nationalite }} 
                                </span>
                            </td>
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Numéro de la pièce : 
                                <span class="intitule"> 
                                    {{ formIdentification.numeroPiece }} 
                                </span>
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Profession : 
                                <span class="intitule"> 
                                    {{ formInformations.profession }} 
                                </span>
                            </td>
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Date d’émission de la pièce : 
                                <span class="intitule"> 
                                    {{ dateEmission }} 
                                </span>
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Mobile: 
                                <span class="intitule"> 
                                    + {{ indice.i.code }} {{ formInformations.telephone }}
                                </span>
                            </td>
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Date d’expiration de la pièce : 
                                <span class="intitule"> 
                                    {{ dateExpiration }} 
                                </span>
                            </td>
                        </tr>

                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">
<!--                            <td style="padding:5px;" class="col-lg-6 mt-2 font-14">-->
<!--                                Nombre de carte(s) : -->
<!--                                <span class="intitule" style="text-transform:uppercase;"> -->
<!--                                    {{ cartesChoisis.length }} -->
<!--                                </span>-->
<!--                            </td>-->
                            <td style="padding:5px;" class="col-lg-6 col-6 mt-2 font-14">
                                Mode de paiement :
                                <span class="intitule" style="text-transform:uppercase;">
                                    {{ mode_paiement }}
                                </span>
                            </td>
                            <td style="padding:5px;" v-if="mode_paiement == 'cash'" class="col-lg-6 col-6 mt-2 font-14">
                                Montant à payer : 
                                <span class="intitule" style="text-transform:uppercase;"> 
                                    {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }} 
                                </span>
                            </td>
                            <td style="padding:5px;" v-if="mode_paiement !== 'cash'" class="col-lg-6 col-6 mt-2 font-14">
                                Montant : 
                                <span class="intitule" style="text-transform:uppercase;"> 
                                    {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant ) }}  
                                </span>
                            </td>
                        </tr>
                        
<!--                        <tr class="row" style="margin-right: 0px; margin-left: 0px;">-->
<!--                            <td style="padding:5px;" class="col-lg-6 mt-2 font-14">-->
<!--                                Mode de paiement : -->
<!--                                <span class="intitule" style="text-transform:uppercase;"> -->
<!--                                    {{ mode_paiement }} -->
<!--                                </span>-->
<!--                            </td>-->
<!--                        </tr>-->
                        
                    </table>

                    <table style="margin-top:10px; font-weight:bold;">
                        <tr>
                            <td class="custom-td">Informations de livraison</td>
                        </tr>
                    </table>
                    <!-- corps -->

                    <!-- Bas de page -->
                    <table style="margin-top:10px; margin-bottom: 5px; line-height: 1.7;">

                        <tr>
                            <td colspan="2" style="padding:5px; padding-top:8px;" v-if="formInformations.choixLivraison == 'Agence'" class="font-14">
                                Veuillez vous rendre à notre agence 
                                <strong v-if="formInformations.lieuLivraison == '1'">
                                    Plateau pyramide, rue BCEAO, après le pullman hôtel. Résidence PELIEU 2e étage
                                </strong>
                                <strong v-if="formInformations.lieuLivraison == '2'">
                                    Cocody Ambassade, Rue Booker Washington près du cabinet children of Africa
                                </strong>
                                <strong v-if="formInformations.lieuLivraison == '4'">
                                    Marcory Zone 4 immeuble pistache et chocolat
                                </strong>
                                muni de votre pièce d'identité valide et votre reçu pour le retrait de votre (vos) carte(s).
                                <br><br>
                                Pour toutes informations complémentaires, merci de bien vouloir contacter le service après-vente par
                                téléphone ou WhatsApp au +225 05 54 175 175 ou par mail à sav@weblogy.com. Merci pour votre confiance.
                            </td>

                            <td colspan="2" v-if="formInformations.choixLivraison == 'Domicile'" class="font-14" style="padding:5px; padding-top:10px;">
                                La livraison se fera à l'adresse suivante :
                                <strong>
                                    {{ formInformations.lieuLivraison }}
                                </strong>.
                                <br><br>
                                Pour toutes informations complémentaires, merci de bien vouloir contacter le service après-vente par
                                téléphone ou WhatsApp au +225 05 54 175 175 ou par mail à sav@weblogy.com. Merci pour votre confiance.
                                
                            </td>
                        </tr>

                        <tr class="row mt-2" style="margin-right: 0px; margin-left: 0px;" v-if="formInformations.choixLivraison == 'Agence'">

                            <td class="col-lg-6 col-6 mt-2 font-14" v-if="formInformations.lieuLivraison == '1'">
                                <strong>Agence Weblogy Plateau</strong><br/>
                                Plateau pyramide, rue BCEAO, après le pullman hôtel. Résidence PELIEU 2e étage<br/>
                                Tel : +225 27 20 334 952<br/>
                            </td>
                            <td class="col-lg-6 col-6 mt-2 font-14" v-if="formInformations.lieuLivraison == '1'">
                                <strong>Horaires</strong><br/>
                                Lundi - Vendredi : 08h - 18h <br>
                                Samedi : 09h - 13h
                            </td>

                            <td class="col-lg-6 col-6 mt-2 font-14" v-if="formInformations.lieuLivraison == '2'">
                                <strong>Agence Weblogy Cocody</strong><br/>
                                Cocody Ambassade, Rue Booker Washington près du cabinet children of Africa<br/>
                                Tel : +225 25 22 010 114<br/>
                            </td>
                            <td class="col-lg-6 col-6 mt-2 font-14" v-if="formInformations.lieuLivraison == '2'">
                                <strong>Horaires</strong><br/>
                                Lundi - Samedi : 08h - 21h <br>
                                Dimanche : 13h - 20h
                            </td>

                            <td class="col-lg-6 col-6 mt-2 font-14" v-if="formInformations.lieuLivraison == '4'">
                                <strong>Agence Weblogy Zone 4</strong><br/>
                                Marcory Zone 4 immeuble pistache et chocolata<br/>
                                Tel : +225 25 21 006 088<br/>
                            </td>
                            <td class="col-lg-6 col-6 mt-2 font-14" v-if="formInformations.lieuLivraison == '4'">
                                <strong>Horaires</strong><br/>
                                Lundi - Vendredi : 08h - 18h <br>
                                Samedi : 09H - 13H
                            </td>

                        </tr>
                        
                    </table>
                    <!-- Bas de page -->

                </div>
                <!-- ******************** -->
                <!-- Reçu de pré-commande -->
                <!-- ******************** -->

                <!-- ******** -->
                <!-- Bloc success payment -->
                <!-- ******** -->
                <success-achat-cartes :hideRecu='hideRecu' :logoOfSelectedService='logoOfSelectedService' :montant='montant'
                    :nombreCartes='cartesChoisis.length' :cinetPayService='cinetPayService' :printPdfRecu="printPdfRecu"
                    :lieuLivraison="formInformations.lieuLivraison" :choixLivraison="formInformations.choixLivraison"
                ></success-achat-cartes>
                <!-- ******** -->
                <!-- Bloc success payment -->
                <!-- ******** -->

                <!-- Body --> 

            </div>
        </div>

        <!-- ****************************** ---->
        <!-- ****************************** ---->
        <!----- Formulaire d'achat de carte ---->
        <!-- ****************************** ---->
        <!-- ****************************** ---->


        <!-- Footer APaym Secured Badge -->
        <footer-item></footer-item>
        <!-- Footer APaym Secured Badge -->

        <!-- Details carte modal -->
        <b-modal ref="openDetialsModal" size="lg" class="modal-content" no-close-on-backdrop>
            <!-- Le Header du modal -->
            <template #modal-header>
                <h3> Détails </h3>
                <button class="close" type="button"
                    @click="closeModal('openDetialsModal')"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </template>

            <!-- Le Body du modal -->
            <form class="container">

                <div class="mb-5 mt-2 row display-for-large-only" style="display: flex; align-items: center; justify-content: space-between;">
                    <div class="col-12 col-lg-2 col-md-2 col-sm-2"></div>
                    <div class="col-12 col-lg-4 col-md-4 col-sm-4">
                        <img :src="require(`../assets/img/cartes/${dataModal.img}`)" 
                            alt="Image carte" style="width: 200px; margin-top: 8px;"
                        >
                    </div>
                    <div class="col-12 col-lg-4 col-md-4 col-sm-4">
                        <div class="flexbox">
                            <div>
                                <h6 class="mb-1 font-18">
                                    <strong>
                                        {{ dataModal.carte }}
                                    </strong>
                                </h6>

                                <div class="text-dark font-16">
                                    Coût : 
                                    <strong>
                                        {{ isNaN( dataModal.cout ) ?  dataModal.cout : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.cout ) }}
                                    </strong>
                                </div>

                                <div class="text-dark font-16">
                                    {{ dataModal.validite }}
                                </div>

                                <div class="text-dark font-16">
                                    Banque partenaire : <strong>{{ dataModal.banque }}</strong>
                                </div>

                                <div class="text-dark font-16">
                                    Carte <strong> {{ dataModal.nature }} </strong>
                                </div>

                                <div class="text-danger mt-1" v-if="dataModal.carte == 'Carte Visa APAYM Pro'" style="margin: 0; font-weight: 900">
                                    Carte Business réservée aux marchands APAYM PRO
                                </div>
                                <a href="https://apaym.com/pro/souscription" class="font-16 mt-2" v-if="dataModal.carte == 'Carte Visa APAYM Pro'"  target="_blank" style="color: #9a802c; padding: 0; font-weight: 900">
                                    Devenir marchand APAYM PRO
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 col-md-2 col-sm-2"></div>
                </div>

                <div class="mb-4 mt-2 row display-for-small-only" style="text-align: center">
                    <div class="col-12 col-lg-2 col-md-2 col-sm-2"></div>
                    <div class="col-12 col-lg-4 col-md-4 col-sm-4">
                        <img :src="require(`../assets/img/cartes/${dataModal.img}`)"
                             alt="Image carte" style="width: 200px; margin-top: 8px;"
                        >
                    </div>
                    <div class="col-12 col-lg-4 col-md-4 col-sm-4">
                        <div class="mt-4">
                            <div>
                                <h6 class="mb-1 font-18">
                                    <strong>
                                        {{ dataModal.carte }}
                                    </strong>
                                </h6>

                                <div class="text-dark font-16">
                                    Coût :
                                    <strong>
                                        {{ isNaN( dataModal.cout ) ?  dataModal.cout : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.cout ) }}
                                    </strong>

                                </div>

                                <div class="text-dark font-16">
                                    {{ dataModal.validite }}
                                </div>

                                <div class="text-dark font-16">
                                    Banque partenaire : <strong>{{ dataModal.banque }}</strong>
                                </div>

                                <div class="text-dark font-16">
                                    Carte <strong> {{ dataModal.nature }} </strong>
                                </div>
                                <div class="text-danger mt-1" v-if="dataModal.carte == 'Carte Visa APAYM Pro'" style="margin: 0; font-weight: 900">
                                    Carte Business réservée aux marchands APAYM PRO
                                </div>
                                <a href="https://apaym.com/pro/souscription" class="font-16 mt-2" v-if="dataModal.carte == 'Carte Visa APAYM Pro'"  target="_blank" style="color: #9a802c; padding: 0; font-weight: 900">
                                    Devenir marchand APAYM PRO
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 col-md-2 col-sm-2"></div>
                </div>

                <strong v-if="dataModal.cout == 0" class="font-15 mb-3" style="display: block; line-height: 1.8; text-align: center;">
                    Téléchargez <a href="https://apaym.com/app" target="_blank" style="color: rgb(52, 102, 203)"> APAYM </a> pour obtenir la carte gratuitement
                </strong>

                <div class="row">

                    <!-- 1ere vague -->
                    <div class="col-12">
                        <div class="padder">
                            <ul class="list-unstyled media-list-divider row">

                                <!-- Plafond de rechargement journalier -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Plafond de rechargement journalier
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.rechargement_journalier ) ?  dataModal.rechargement_journalier : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.rechargement_journalier ) }}
                                                <!-- {{ dataModal.rechargement_journalier }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Frais de gestion mensuelle -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Frais de gestion mensuelle
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.frais_mensuel ) ?  dataModal.frais_mensuel : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.frais_mensuel ) }}
                                                <!-- {{ dataModal.frais_mensuel }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Frais de rechargement de la carte en espèce -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div style="width: 100%" class="pr-5">
                                            <h5 class="font-15">
                                                Frais de rechargement en espèces
                                            </h5>
                                            <h5 class="font-12" v-if=" dataModal.montant_minimum_rechargement !== '--' ">
                                                *Montant Minimum : 
                                                <span style="font-weight: 800;">
                                                    {{ isNaN( dataModal.montant_minimum_rechargement ) ?  dataModal.montant_minimum_rechargement : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.montant_minimum_rechargement ) }}
                                                    <!-- {{ dataModal.montant_minimum_rechargement }} -->
                                                </span>
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.frais_chargement_espece ) ?  dataModal.frais_chargement_espece : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.frais_chargement_espece ) }}
                                                <!-- {{ dataModal.frais_chargement }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Frais de rechargement de la carte dans l'app APAYM -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div style="width: 100%" class="pr-5">
                                            <h5 class="font-15">
                                                Frais de rechargement dans l'app APAYM (Mobile Money, Virement)
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.frais_chargement_app ) ?  dataModal.frais_chargement_app : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.frais_chargement_app ) }}
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Plafond mensuel -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Plafond de rechargement mensuel
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.plafond_mensuel ) ?  dataModal.plafond_mensuel : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.plafond_mensuel ) }}
                                                <!-- {{ dataModal.plafond_mensuel }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Retrait DAB/GAB domestique -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Retrait DAB/GAB domestique
                                            </h5>
                                            <h5 class="font-12" v-if=" dataModal.montant_minimum_retrait_domestique !== '--' ">
                                                *Montant minimum :
                                                <span style="font-weight: 800;"> 
                                                    {{ isNaN( dataModal.montant_minimum_retrait_domestique ) ?  dataModal.montant_minimum_retrait_domestique : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.montant_minimum_retrait_domestique ) }}
                                                    <!-- {{ dataModal.montant_minimum_retrait_domestique }}  -->
                                                </span>
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);"> 
                                                {{ isNaN( dataModal.retrait_domestique ) ?  dataModal.retrait_domestique : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.retrait_domestique ) }}
                                                <!-- {{ dataModal.retrait_domestique }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Retrait DAB/GAB GIM-UEMOA -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Retrait DAB/GAB GIM-UEMOA
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.retrait_gim ) ?  dataModal.retrait_gim : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.retrait_gim ) }}
                                                <!-- {{ dataModal.retrait_gim }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                
                                <!-- Retrait DAB/GAB domestiques chez confrères -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Retrait DAB/GAB domestiques chez confrères
                                            </h5>
                                            <h5 class="font-12" v-if=" dataModal.montant_minimum_retrait_confreres !== '--' ">
                                                *Montant minimum :
                                                <span style="font-weight: 800;">
                                                    {{ isNaN( dataModal.montant_minimum_retrait_confreres ) ?  dataModal.montant_minimum_retrait_confreres : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.montant_minimum_retrait_confreres ) }}
                                                    <!-- {{ dataModal.montant_minimum_retrait_confreres }} -->
                                                </span>
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.retrait_confreres ) ?  dataModal.retrait_confreres : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.retrait_confreres ) }}
                                                <!-- {{ dataModal.retrait_confreres }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Retrait DAB/GAB international -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Retrait DAB/GAB international
                                            </h5>
                                            <h5 class="font-12" v-if=" dataModal.montant_minimum_retrait_inter !== '--' ">
                                                *Montant minimum :
                                                <span style="font-weight: 800;">
                                                    {{ isNaN( dataModal.montant_minimum_retrait_inter ) ?  dataModal.montant_minimum_retrait_inter : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.montant_minimum_retrait_inter ) }}
                                                    <!-- {{ dataModal.montant_minimum_retrait_inter }} -->
                                                </span>
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.retrait_international ) ?  dataModal.retrait_international : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.retrait_international ) }}
                                                <!-- {{ dataModal.retrait_international }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Achat TPE national -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Achat TPE national
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.tpe_national ) ?  dataModal.tpe_national : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.tpe_national ) }}
                                                <!-- {{ dataModal.tpe_national }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Achat TPE international -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Achat TPE international
                                            </h5>
                                            <h5 class="font-12" v-if=" dataModal.montant_minimum_tpe_inter !== '--' ">
                                                *Montant minimum :
                                                <span style="font-weight: 800;">
                                                    {{ isNaN( dataModal.montant_minimum_tpe_inter ) ?  dataModal.montant_minimum_tpe_inter : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.montant_minimum_tpe_inter ) }}
                                                    <!-- {{ dataModal.montant_minimum_tpe_inter }} -->
                                                </span>
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.tpe_international ) ?  dataModal.tpe_international : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.tpe_international ) }}
                                                <!-- {{ dataModal.tpe_international }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Transfert carte a carte -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Transfert carte à carte
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.transfert_carte_carte ) ?  dataModal.transfert_carte_carte : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.transfert_carte_carte ) }}
                                                <!-- {{ dataModal.transfert_carte_carte }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Frais sur internet -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Frais sur internet
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.frais_internet ) ?  dataModal.frais_internet : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.frais_internet ) }}
                                                <!-- {{ dataModal.frais_internet }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>

                                <!-- Montant maximum de débit sur internet par transaction -->
                                <li class="col-12 colg-6 col-md-6 col-sm-6 media py-3 align-items-center">
                                    <div class="media-body flexbox">
                                        <div>
                                            <h5 class="font-15">
                                                Montant maximum de débit sur internet par transaction
                                            </h5>
                                        </div>
                                        <div class="font-15" style="font-weight: 800; text-align: end;">
                                            <span style="color: rgb(52, 102, 203);">
                                                {{ isNaN( dataModal.montant_max_sur_internet ) ?  dataModal.montant_max_sur_internet : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( dataModal.montant_max_sur_internet ) }}
                                                <!-- {{ dataModal.montant_max_sur_internet }} -->
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </form>
            <!-- Le Body du modal -->

            <!-- Le Footer du modal -->
            <template #modal-footer>
                <button class="btn btn-light" type="button"
                    @click="closeModal('openDetialsModal')"
                >
                    <span class="btn-icon">Fermer</span>
                </button>
            </template>
        </b-modal>
        <!-- Details carte modal -->

        <!-- Wave modal -->
        <b-modal
            class="modal-content"
            id="openWave"
            ref="openWaveModal"
            no-close-on-backdrop hide-footer 
            hide-header scrollable 
            style="padding: 0;" size="lg"
        >
            <!-- Close modal : For Large screen only -->
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                @click="closeModal('openWaveModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <!-- Close modal : For Large screen only -->

            <!-- Close modal : For Small screen only -->
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                @click="closeModal('openWaveModal')"
            >
                <i class="fas fa-times" style="font-size: 23px; color: #ffffff"></i>
            </div>
            <!-- Close modal : For Small screen only -->

            <div class="modalOrangeMoney">
                <iframe
                    :src="urlWave"
                    frameborder="0"
                    scrolling="yes"
                    style="height: inherit; width: 100%;"
                ></iframe>
            </div>

        </b-modal>
        <!-- Wave modal -->

        <!-- Orange money modal -->
        <b-modal
            class="modal-content"
            id="openOrangeMoney"
            ref="openOrangeMoneyModal"
            no-close-on-backdrop hide-footer 
            hide-header scrollable 
            style="padding: 0;" size="lg"
        >
            <!-- Close modal : For Large screen only -->
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                @click="closeModal('openOrangeMoneyModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <!-- Close modal : For Large screen only -->

            <!-- Close modal : For Small screen only -->
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                @click="closeModal('openOrangeMoneyModal')"
            >
                <i class="fas fa-times" style="font-size: 23px; color: #ffffff"></i>
            </div>
            <!-- Close modal : For Small screen only -->

            <div class="modalOrangeMoney">
                <iframe
                    :src="urlOrange"
                    frameborder="0"
                    scrolling="yes"
                    style="height: inherit; width: 100%;"
                ></iframe>
            </div>

        </b-modal>
        <!-- Orange money modal -->

        <!-- BICICI modal -->
        <b-modal class="modal-content" id="openBicici" ref="openBiciciModal"
            no-close-on-backdrop hide-footer hide-header scrollable style="padding: 0;" size="lg"
        >
            <div class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                 @click="closeModal('openBiciciModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                 @click="closeModal('openBiciciModal')"
            >
                <i class="fas fa-times" style="font-size: 23px;"></i>
            </div>
            <div class="modalBiciciMoney">
                <iframe :src="contentBicici" frameborder="0" scrolling="yes" style="height: inherit; width: 100%;" ></iframe>
            </div>
        </b-modal>
        <!-- BICICI modal -->
         
    </div>
</template>

<script>
    import ChoixCartes from "../components/AchatCartes/ChoixCartes";
    import EtapesCommande from "../components/AchatCartes/EtapesCommande";
    import FormInformations from "../components/AchatCartes/FormInformations";
    export default {
        components: { FormInformations, EtapesCommande, ChoixCartes }
    }
</script>
<script>

    import Loading from "vue-loading-overlay" ;
    import "vue-loading-overlay/dist/vue-loading.css" ;
    import TopBar from "../components/TopBar" ;
    import FooterItem from "../components/FooterItem" ; 
    import flags from "../constants/flags.json" ; 
    import Multiselect from "vue-multiselect" ;
    import html2pdf from 'html2pdf.js';
    import { sweetAlert } from "../constants/functions" ;
    // import { setTitleMeta } from "../meta/meta" ;
    import axios from "axios" ;
    import { apiUrl } from "../constants/config" ;
    import SuccessAchatCartes from "../components/SuccessAchatCartes" ;
    import ChoixCartes from "../components/AchatCartes/ChoixCartes";
    import EtapesCommande from "../components/AchatCartes/EtapesCommande";
    import FormInformations from "../components/AchatCartes/FormInformations";
    import FormIdentification from "../components/AchatCartes/FormIdentification";
    import { trim } from "jquery" ;
 
    const TIME_LIMIT = 90;

    export default {
        // name: 'AchatCartesVisa',
        metaInfo: {
            // if no subcomponents specify a metaInfo.title, this title will be used
            title: 'APAYM Cabine',
            // all titles will be injected into this template
            titleTemplate: 'Achat de cartes Visa prépayées |  %s'
        },
        components: {
            Loading,
            'top-bar': TopBar,
            'footer-item': FooterItem,
            multiselect: Multiselect,
            'success-achat-cartes': SuccessAchatCartes,
            'choix-cartes': ChoixCartes,
            'etapes-commande': EtapesCommande,
            'form-informations': FormInformations,
            'form-identification': FormIdentification
        },
        data() {
            return {
                // title: 'Achat de cartes Visa prépayées |  Cabine',
                checkCard: true, isLoading: false, fullPage: true,
                cartesChoisis: [],
                dataModal: {
                    carte: "",
                    img: "Carte-classique.png",
                    banque: "",
                    cout: "",
                    nature: "",
                    validite: "",
                    frais_mensuel: "",
                    rechargement_journalier: "",
                    plafond_mensuel: "",
                    frais_chargement: "",
                    montant_minimum_rechargement: "",
                    retrait_domestique: "",
                    montant_minimum_retrait_domestique: "",
                    retrait_gim: "",
                    retrait_confreres: "",
                    montant_minimum_retrait_confreres: "",
                    retrait_international: "",
                    montant_minimum_retrait_inter: "",
                    tpe_national: "",
                    tpe_international: "",
                    montant_minimum_tpe_inter: "",
                    transfert_carte_carte: "",
                    frais_internet: "",
                    montant_max_sur_internet: ""
                },
                listeCartes:[
                    {
                        "id" : 1,
                        "img" : "Carte-classique.png",
                        "carte" : "Carte Visa Classic",
                        "couleur" : "Noire",
                        "check" : false,
                        "free" : false,
                        "montant": 10000,
                        "validite": "Validité : 3 ans",
                        "banque": "NSIA",
                        "nature": "Physique",
                        "frais_mensuel": 750,
                        "rechargement_journalier": 2000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": 5000,
                        "retrait_domestique": "Gratuit",
                        "montant_minimum_retrait_domestique": 5000,
                        "retrait_gim": "Gratuit",
                        "retrait_confreres": "Gratuit",
                        "montant_minimum_retrait_confreres": 5000,
                        "retrait_international": "2,2%",
                        "montant_minimum_retrait_inter": 2500,
                        "tpe_national": "Gratuit",
                        "tpe_international": "1,5%",
                        "montant_minimum_tpe_inter": 585,
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "1,5%",
                        "montant_max_sur_internet": 1000000
                    },
                    {
                        "id" : 2,
                        "img" : "Carte-platinum-noire.png",
                        "carte" : "Carte Visa Platinum Noir",
                        "couleur" : "Noire",
                        "check" : false,
                        "free" : false,
                        "montant": 50000,
                        "validite": "Validité : 3 ans",
                        "banque": "UBA",
                        "nature": "Physique",
                        "frais_mensuel": "Gratuit",
                        "rechargement_journalier": 3000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": 100000,
                        "retrait_domestique": "Gratuit",
                        "montant_minimum_retrait_domestique": 5000,
                        "retrait_gim": "Gratuit",
                        "retrait_confreres": "Gratuit",
                        "montant_minimum_retrait_confreres": 5000,
                        "retrait_international": 300,
                        "montant_minimum_retrait_inter": 2500,
                        "tpe_national": "Gratuit",
                        "tpe_international": "3,3%",
                        "montant_minimum_tpe_inter": "--",
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "3,3%",
                        "montant_max_sur_internet": 2000000
                    },
                    {
                        "id" : 3,
                        "img" : "Carte-platinum-blanche.png",
                        "carte" : "Carte Visa Platinum Blanche",
                        "couleur" : "Blance",
                        "check" : false,
                        "free" : false,
                        "montant": 50000,
                        "validite": "Validité : 3 ans",
                        "banque": "UBA",
                        "nature": "Physique",
                        "frais_mensuel": "Gratuit",
                        "rechargement_journalier": 3000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": 100000,
                        "retrait_domestique": "Gratuit",
                        "montant_minimum_retrait_domestique": 5000,
                        "retrait_gim": "Gratuit",
                        "retrait_confreres": "Gratuit",
                        "montant_minimum_retrait_confreres": 5000,
                        "retrait_international": 300,
                        "montant_minimum_retrait_inter": 2500,
                        "tpe_national": "Gratuit",
                        "tpe_international": "3,3%",
                        "montant_minimum_tpe_inter": "--",
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "3,3%",
                        "montant_max_sur_internet": 2000000
                    },
                    {
                        "id" : 4,
                        "img" : "Carte-platinum-noire-ccs.png",
                        "carte" : "Carte Visa Platinum Ccs12 Noir",
                        "couleur" : "Noire",
                        "check" : false,
                        "free" : false,
                        "montant": 60000,
                        "validite": "Validité : 3 ans",
                        "banque": "UBA",
                        "nature": "Physique",
                        "frais_mensuel": "Gratuit",
                        "rechargement_journalier": 3000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": 100000,
                        "retrait_domestique": "Gratuit",
                        "montant_minimum_retrait_domestique": "--",
                        "retrait_gim": "Gratuit",
                        "retrait_confreres": "Gratuit",
                        "montant_minimum_retrait_confreres": 5000,
                        "retrait_international": 300,
                        "montant_minimum_retrait_inter": 2500,
                        "tpe_national": "Gratuit",
                        "tpe_international": "3,3%",
                        "montant_minimum_tpe_inter": "--",
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "3,3%",
                        "montant_max_sur_internet": 2000000
                    },
                    {
                        "id" : 5,
                        "img" : "Carte-platinum-blanche-ccs.png",
                        "carte" : "Carte Visa Platinum Ccs12 Blanche",
                        "couleur" : "Noire",
                        "check" : false,
                        "free" : false,
                        "montant": 60000,
                        "validite": "Validité : 3 ans",
                        "banque": "UBA",
                        "nature": "Physique",
                        "frais_mensuel": "Gratuit",
                        "rechargement_journalier": 3000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": 100000,
                        "retrait_domestique": "Gratuit",
                        "montant_minimum_retrait_domestique": "--",
                        "retrait_gim": "Gratuit",
                        "retrait_confreres": "Gratuit",
                        "montant_minimum_retrait_confreres": 5000,
                        "retrait_international": 300,
                        "montant_minimum_retrait_inter": 2500,
                        "tpe_national": "Gratuit",
                        "tpe_international": "3,3%",
                        "montant_minimum_tpe_inter": "--",
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "3,3%",
                        "montant_max_sur_internet": 2000000
                    },
                    {
                        "id" : 6,
                        "img" : "Carte-virtuelle-uba.png",
                        "carte" : "Carte Visa Virtuelle APAYM",
                        "couleur" : "Noir",
                        "check" : false,
                        "free" : true,
                        "montant": 0,
                        "validite": "Validité : 2 ans",
                        "banque": "UBA",
                        "nature": "Virtuelle",
                        "frais_mensuel": "Gratuit",
                        "rechargement_journalier": 2000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": 1000,
                        "retrait_domestique": "N/A",
                        "montant_minimum_retrait_domestique": "--",
                        "retrait_gim": "N/A",
                        "retrait_confreres": "N/A",
                        "montant_minimum_retrait_confreres": "--",
                        "retrait_international": "N/A",
                        "montant_minimum_retrait_inter": "--",
                        "tpe_national": "N/A",
                        "tpe_international": "N/A",
                        "montant_minimum_tpe_inter": "--",
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "3,3%",
                        "montant_max_sur_internet": 1500000
                    },
                    {
                        "id" : 7,
                        "img" : "Carte-apaym-pro.png",
                        "carte" : "Carte Visa APAYM Pro",
                        "couleur" : "Jaune or",
                        "check" : false,
                        "free" : false,
                        "montant": 5000,
                        "validite": "Validité : 3 ans",
                        "banque": "ECOBANK",
                        "nature": "Physique",
                        "frais_mensuel": "Gratuit",
                        "rechargement_journalier": 2000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": 5000,
                        "retrait_domestique": "Gratuit",
                        "montant_minimum_retrait_domestique": "--",
                        "retrait_gim": "Gratuit",
                        "retrait_confreres": "Gratuit",
                        "montant_minimum_retrait_confreres": "--",
                        "retrait_international": "2,4%",
                        "montant_minimum_retrait_inter": "--",
                        "tpe_national": "Gratuit",
                        "tpe_international": "1,5%",
                        "montant_minimum_tpe_inter": "--",
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "2%",
                        "montant_max_sur_internet": 2000000
                    },
                    {
                        "id" : 8,
                        "img" : "Carte-Virtuelle-Ecobank-Apaym.png",
                        "carte" : "Carte Visa Virtuelle APAYM",
                        "couleur" : "Bleu",
                        "check" : false,
                        "free" : true,
                        "montant": 0,
                        "validite": "Validité : 3 ans",
                        "banque": "ECOBANK",
                        "nature": "Virtuelle",
                        "frais_mensuel": "Gratuit",
                        "rechargement_journalier": 2000000,
                        "plafond_mensuel": 10000000,
                        "frais_chargement_espece": "1%",
                        "frais_chargement_app": "0%",
                        "montant_minimum_rechargement": "--",
                        "retrait_domestique": "N/A",
                        "montant_minimum_retrait_domestique": "--",
                        "retrait_gim": "N/A",
                        "retrait_confreres": "N/A",
                        "montant_minimum_retrait_confreres": "--",
                        "retrait_international": "N/A",
                        "montant_minimum_retrait_inter": "--",
                        "tpe_national": "N/A",
                        "tpe_international": "N/A",
                        "montant_minimum_tpe_inter": "--",
                        "transfert_carte_carte": "Gratuit",
                        "frais_internet": "2%",
                        "montant_max_sur_internet": 1000000
                    },
                    // {
                    //     "id" : 9,
                    //     "img" : "Carte-phoenix.png",
                    //     "carte" : "Carte Visa Phenix",
                    //     "couleur" : "",
                    //     "check" : false,
                    //     "free" : false,
                    //     "montant": 10000,
                    //     "validite": "Validité : 3 ans",
                    //     "banque": "BHCI",
                    //     "nature": "Physique",
                    //     "frais_mensuel": 550,
                    //     "rechargement_journalier": 2000000,
                    //     "plafond_mensuel": 10000000,
                    //     "frais_chargement_espece": "2%",
                    //     "frais_chargement_app": "2%",
                    //     "montant_minimum_rechargement": 1100,
                    //     "retrait_domestique": "Gratuit (Réseau BHCI)",
                    //     "montant_minimum_retrait_domestique": "--",
                    //     "retrait_gim": 500,
                    //     "retrait_confreres": 500,
                    //     "montant_minimum_retrait_confreres": "--",
                    //     "retrait_international": 3300,
                    //     "montant_minimum_retrait_inter": "--",
                    //     "tpe_national": "Gratuit",
                    //     "tpe_international": "3,3%",
                    //     "montant_minimum_tpe_inter": "--",
                    //     "transfert_carte_carte": 1100,
                    //     "frais_internet": "3,3%",
                    //     "montant_max_sur_internet": 1000000
                    // },
                ],
                pays: [], indice: { i: "225" }, indiceTelephone:{ i: "225" },
                indiceMobileMoney: "225", dataMoMo: { numero : "" }, dataMoov: { numero : "" },
                dataAPaym: { indicatif: "225", numero : "", codeApaym: "" }, dataApaymPayAuth: { indicatif: "225", numero : "", code: "", token: "" },
                showFormInformations: false, showFormIdentification: false, showFormPaiement: false,
                formInformations:{
                    "civilite": "", "nom": "", "prenom": "",
                    "telephone": "", "dateNaissance": "",
                    "paysNaissance": "Cote d'Ivoire",
                    "nationalite": "Cote d'Ivoire",
                    "email": "", "profession": "",
                    "adresse": "", "ville": "",
                    "choixLivraison": "", "lieuLivraison": ""
                },
                formIdentification:{
                    "mineur": false, "typePiece": "", "numeroPiece": "",
                    "dateEmission": "", "dateExpiration": "", "piece": null,
                    "pieceParent": null
                },
                mode_paiement: "", montant: 0, printPdf: false, dateNaissance: "", dateEmission: "",
                dateExpiration: "", refID: "", datePrecommande: "", showContent: false,
                mtnOkay: false, mtnNOkay: false, orangeOkay: false, orangeNOkay: false,
                moovOkay: false, moovNOkay: false, mobileDevice: false, waveOkay: false,
                waveNOkay: false, modalOrange: false, modalWave: false, hideRecu: true,
                logoOfSelectedService: "om.png", urlOrange: "", urlWave: "", reloadSuccess: false,
                reloadFailure: false, cinetPayOkay: false, cinetPayNOkay: false, cinetPayService: "", urlCinetPay: "",
                modalCinetPay: false, timePassed: 0, timerInterval: null, showVerifMoov: false, hideCodePay: false,
                showInProcessMoov: false, stopInterval: null, options: [], apaymOkay: false, apaymNOkay: false,
                contentBicici: "", formBicici: false, modalBicici: false, biciciNOkay: false, apaymNOkay2: false,
                showCard: false, cards: [], cardsLength: 0, loginApaym: true, frais: 0
            }
        },
        computed: {

            formattedTimeLeft()
            {
                const timeLeft = this.timeLeft;
                const minutes = Math.floor(timeLeft / 60);
                let seconds = timeLeft % 60;

                if (seconds < 10) {
                    seconds = `0${seconds}`;
                }

                return `${minutes}:${seconds}`;
            },

            timeLeft()
            {
                return TIME_LIMIT - this.timePassed;
            },
        },
        methods: {

            onCancel() 
            {
                console.log('Loader dismiss') ;
            },

            changerMenu()
            {
                this.showContent = false ;
                this.showFormPaiement = true ;
            },

            // Voir les détails d'une carte
            voirDetails(carte)
            {
                // console.log(carte)
                this.dataModal.carte = carte.carte; 
                this.dataModal.banque = carte.banque;
                this.dataModal.cout = carte.montant;
                this.dataModal.img = carte.img;
                this.dataModal.validite = carte.validite;
                this.dataModal.nature = carte.nature;
                this.dataModal.frais_mensuel = carte.frais_mensuel;
                this.dataModal.rechargement_journalier = carte.rechargement_journalier;
                this.dataModal.plafond_mensuel = carte.plafond_mensuel;
                this.dataModal.frais_mensuel = carte.frais_mensuel;
                this.dataModal.frais_chargement_app = carte.frais_chargement_app;
                this.dataModal.frais_chargement_espece = carte.frais_chargement_espece;
                this.dataModal.montant_minimum_rechargement = carte.montant_minimum_rechargement;
                this.dataModal.retrait_domestique = carte.retrait_domestique;
                this.dataModal.montant_minimum_retrait_domestique = carte.montant_minimum_retrait_domestique;
                this.dataModal.retrait_gim = carte.retrait_gim;
                this.dataModal.retrait_confreres = carte.retrait_confreres;
                this.dataModal.montant_minimum_retrait_confreres = carte.montant_minimum_retrait_confreres;
                this.dataModal.retrait_international = carte.retrait_international;
                this.dataModal.montant_minimum_retrait_inter = carte.montant_minimum_retrait_inter;
                this.dataModal.tpe_national = carte.tpe_national;
                this.dataModal.tpe_international = carte.tpe_international;
                this.dataModal.montant_minimum_tpe_inter = carte.montant_minimum_tpe_inter;
                this.dataModal.transfert_carte_carte = carte.transfert_carte_carte;
                this.dataModal.frais_internet = carte.frais_internet;
                this.dataModal.montant_max_sur_internet = carte.montant_max_sur_internet;

                this.$refs['openDetialsModal'].show();
            },

            closeModal(refModal)
            {
                
                this.$refs[refModal].hide() ;
            },

            // Sélectionner une carte Visa
            choisirCarte(carte)
            {
                carte.check = !carte.check ;

                // Ajouter la carte
                if ( carte.check == true ) {
                    this.cartesChoisis.push(carte) ;
                    return false;
                } 
                
                // Retirer la carte
                this.removeObjectWithId(this.cartesChoisis, carte.id) ;
                // console.table(this.cartesChoisis);
            },

            // Enlever une carte dans le tableau des cartes choisis
            removeObjectWithId(arr, id) {
                
                const objWithIdIndex = arr.findIndex((obj) => obj.id === id);

                if (objWithIdIndex > -1) {
                    arr.splice(objWithIdIndex, 1);
                }

                return arr;
            },

            removeCarteFromListe(carte)
            {
                carte.check = !carte.check ;

                // Retirer la carte
                this.removeObjectWithId(this.cartesChoisis, carte.id) ;

                // On calcule le montant total à payer
                const sum = this.cartesChoisis.reduce((accumulator, value) => {
                    return accumulator + value.montant;
                }, 0);

                // Montant total à payer = sum + 2% de sum
                // this.montant = sum + ( 0.02 * sum ) ;
                this.montant = sum ;
                this.frais = 0.02 * sum ;

            },

            // Valider le choix des cartes et aller sur le formulaire des coordonnées
            validerCartes()
            {

                // On calcule le montant total à payer
                const sum = this.cartesChoisis.reduce((accumulator, value) => {
                    return accumulator + value.montant;
                }, 0);

                // Montant total à payer = sum + 2% de sum
                // this.montant = sum + ( 0.02 * sum ) ;
                this.montant = sum ;
                this.frais = 0.02 * sum ;

                this.checkCard = !this.checkCard ;
                this.showFormInformations = true ;

                this.scrollToTop();

                // console.log(JSON.stringify(this.cartesChoisis))
            },

            // Valider les informations et aller sur le formulaire pour la pièce d'identité
            formIdentificationNext()
            {
                // var d = new Date(this.formInformations.dateNaissance);
                // var month = d.getUTCMonth() + 1 ;
                // month = month < 10 ? "0"+ month : month ;
                // var day = d.getUTCDate() ;
                // day = day < 10 ? "0"+ day : day ;
                // this.dateNaissance = day +"/"+ month +"/"+ d.getUTCFullYear() ;
                // console.log("Date 2 = "+ day +"/"+ month +"/"+ d.getUTCFullYear())

                if ( 
                    this.formInformations.civilite == "" ||
                    this.formInformations.nom.replace(/\s/g, "") == "" ||
                    this.formInformations.prenom.replace(/\s/g, "") == "" ||
                    this.formInformations.telephone.replace(/\s/g, "") == "" ||
                    this.formInformations.dateNaissance == "" ||
                    this.formInformations.paysNaissance == "" ||
                    this.formInformations.nationalite == "" ||
                    this.formInformations.email.replace(/\s/g, "") == "" ||
                    this.formInformations.choixLivraison == ""
                )
                {

                    this.$swal({
                        title: 'Données requises !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner toutes les informations obligatoires avant de continuer.</span>",
                    }); 

                    this.scrollToTop();
                    return false ;
                }

                if ( this.formInformations.choixLivraison == "Agence" ) 
                {
                    if ( this.formInformations.lieuLivraison == "" )
                    {
                        this.$swal({
                            title: 'Donnée requise !',
                            icon: 'info',
                            html:"<span class='font-18' style='line-height: 1.6'>Veuillez sélectionner une agence Weblogy !</span>",
                        });  
                        
                        return false ;
                    }

                } else 
                {
                    if ( this.formInformations.lieuLivraison == "" )
                    {
                        this.$swal({
                            title: 'Donnée requise !',
                            icon: 'info',
                            html:"<span class='font-18' style='line-height: 1.6'>Veuillez préciser le lieu de livraison !</span>",
                        });   

                        return false ;
                    }
                }


                if ( !this.validateString( trim(this.formInformations.nom) ) )
                {

                    this.$swal({
                        title: 'Donnée requise !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner un nom correct !</span>",
                    });

                    return false ;
                }

                if ( !this.validateString( trim(this.formInformations.prenom) ) )
                {

                    this.$swal({
                        title: 'Donnée requise !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner un prénom correct !</span>",
                    });

                    return false ;
                }

                if ( !this.validateEmail( trim(this.formInformations.email) ) )
                {

                    this.$swal({
                        title: 'Donnée requise !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner une adresse e-mail correcte !</span>",
                    });

                    return false ;
                }


                if ( this.formInformations.profession !== "" )
                {
                    if ( !this.validateSpecialString( trim(this.formInformations.profession) ) )
                    {

                        this.$swal({
                            title: 'Donnée requise !',
                            icon: 'info',
                            html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner une profession correcte !</span>",
                        });

                        return false ;
                    }
                }


                if ( this.formInformations.lieuLivraison !== "" )
                {
                    if ( !this.validateSpecialString( trim(this.formInformations.lieuLivraison) ) )
                    {

                        this.$swal({
                            title: 'Donnée requise !',
                            icon: 'info',
                            html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner un lieu de livraison correct !</span>",
                        });

                        return false ;
                    }
                }


                this.showFormInformations = !this.showFormInformations ;
                this.showFormIdentification = !this.showFormIdentification ;
                this.scrollToTop();
            },

            // Retourner sur le formulaire des coordonnées
            formInfosReturn()
            {
                this.showFormInformations = true ;//!this.showFormInformations ;
                this.showFormIdentification = false ;//!this.showFormIdentification ;
                this.scrollToTop();
            },

            formPaiementNext()
            {
                if ( 
                    this.formIdentification.typePiece == "" || 
                    this.formIdentification.numeroPiece.replace(/\s/g, "") == "" || 
                    this.formIdentification.dateEmission == "" || 
                    this.formIdentification.dateExpiration == "" ||
                    this.formIdentification.piece == null
                ) {

                    this.$swal({
                        title: 'Données requises !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner toutes les informations obligatoires avant de continuer.</span>",
                    });

                    this.scrollToTop();
                    return false ;
                }

                if ( this.formIdentification.dateEmission > this.formIdentification.dateExpiration )
                {

                    this.$swal({
                        title: 'Données inccorectes !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner des dates d'émission et d'expiration correctes.</span>",
                    });

                    return false ;

                }

                // Si il s'agit d'un mineur
                if ( this.formIdentification.mineur )
                {
                    if ( this.formIdentification.pieceParent == null )
                    {
                        this.$swal({
                            title: 'Donnée requise !',
                            icon: 'info',
                            html:"<span class='font-18' style='line-height: 1.6'>Veuillez télécharger votre autorisation parentale !</span>",
                        });

                        this.scrollToTop();
                        return false ;
                    }
                }


                if ( !this.validateSpecialString( trim(this.formIdentification.numeroPiece) ) )
                {

                    this.$swal({
                        title: 'Donnée requise !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Veuillez renseigner un numéro de pièce correct !</span>",
                    });

                    return false ;
                }

                // const [year, month, day] = this.formInformations.dateNaissance.split('-');
                // this. dateNaissance = [day, month, year].join('/');
                var d = new Date(this.formInformations.dateNaissance);
                var month = d.getUTCMonth() + 1 ;
                month = month < 10 ? "0"+ month : month ;
                var day = d.getUTCDate() ;
                day = day < 10 ? "0"+ day : day ;
                this.dateNaissance = day +"/"+ month +"/"+ d.getUTCFullYear() ;
                // console.log("Date 2 = "+ d.getUTCDate() +"/"+ month +"/"+ d.getUTCFullYear())

                // const [year2, month2, day2] = this.formIdentification.dateEmission.split('-');
                // this.dateEmission = [day2, month2, year2].join('/');
                var d = new Date(this.formIdentification.dateEmission);
                var month = d.getUTCMonth() + 1 ;
                month = month < 10 ? "0"+ month : month ;
                var day = d.getUTCDate() ;
                day = day < 10 ? "0"+ day : day ;
                this.dateEmission = day +"/"+ month +"/"+ d.getUTCFullYear() ;

                // const [year3, month3, day3] = this.formIdentification.dateExpiration.split('-');
                // this.dateExpiration = [day3, month3, year3].join('/');
                var d = new Date(this.formIdentification.dateExpiration);
                var month = d.getUTCMonth() + 1 ;
                month = month < 10 ? "0"+ month : month ;
                var day = d.getUTCDate() ;
                day = day < 10 ? "0"+ day : day ;
                this.dateExpiration = day +"/"+ month +"/"+ d.getUTCFullYear() ;

                // console.log(this.montant);

                // On procède à l'enregistrement des informations avec Paiement
                // On demande à l'utilisateur de s'assurer de l'authenticité des informations renseignées avant validation
                this.$swal({
                    title: 'Êtes-vous certain(e) ?',
                    html: "<div class='font-18' style='line-height: 1.6'>Vous allez soumettre les informations renseignées, soyez certain d'avoir saisi les bonnes données.</div>",
                    icon: 'info',
                    showCancelButton: true,
                    cancelButtonColor: '#6e7881',
                    confirmButtonText: 'Oui, je valide !',
                    cancelButtonText: 'Non',
                    reverseButtons: false
                }).then((result) => {

                    if (result.isConfirmed) {

                        console.log("************* Validation en cours *************");
                        this.isLoading = true;

                        let dataToSend = new FormData();
                        dataToSend.append("dateNaissance", this.dateNaissance);
                        dataToSend.append("pieceParent", this.formIdentification.pieceParent ? this.formIdentification.pieceParent : "");
                        dataToSend.append("piece", this.formIdentification.piece);
                        dataToSend.append("numero", this.formInformations.telephone.replace(/\s/g, ""));
                        dataToSend.append("indicatif", this.indice.i.code);
                        dataToSend.append("nom", this.formInformations.nom);
                        dataToSend.append("prenom", this.formInformations.prenom);
                        dataToSend.append("mineur", this.formIdentification.mineur ? "oui" : "non");
                        dataToSend.append("choixLivraison", this.formInformations.choixLivraison);
                        dataToSend.append("lieuLivraison", this.formInformations.lieuLivraison);
                        dataToSend.append("paysNaissance", this.indice.i.alpha2);
                        dataToSend.append("nationalite", this.formInformations.nationalite);
                        dataToSend.append("email", this.formInformations.email);
                        dataToSend.append("profession", this.formInformations.profession);
                        dataToSend.append("adresse", this.formInformations.adresse);
                        dataToSend.append("ville", this.formInformations.ville);
                        dataToSend.append("typePiece", this.formIdentification.typePiece);
                        dataToSend.append("numeroPiece", this.formIdentification.numeroPiece);
                        dataToSend.append("dateEmissionPiece", this.dateEmission);
                        dataToSend.append("dateExpirationPiece", this.dateExpiration);
                        dataToSend.append("civilite", this.formInformations.civilite);
                        dataToSend.append("pays", this.formInformations.paysNaissance);
                        dataToSend.append("cartes", JSON.stringify(this.cartesChoisis));
                        dataToSend.append("montant", this.montant);

                        axios.post(apiUrl + 'api/cartes/commander-carte',
                            dataToSend,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }
                        ).then(response => {

                            this.isLoading = false;

                            if ( response.data["code"] == 1 )
                            {

                                this.refID = response.data["refID"] ;
                                window.localStorage.setItem("_reference_", response.data["refID"]) ;
                                this.datePrecommande = response.data["datePrecommande"] ;

                                this.showFormIdentification = !this.showFormIdentification ;
                                this.showFormPaiement = !this.showFormPaiement ;

                                this.scrollToTop();
                                return false;
                            }

                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                        }).catch(error => {

                            this.isLoading = false;
                            console.log(error);
                            sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', "Une erreur est survenue, veuillez réessayer plus tard");

                        });
                    }
                });

            },

            // Retourner sur le formulaire de l'identification (Pièce)
            formIdentificationReturn()
            {
                this.showFormIdentification = !this.showFormIdentification ;
                this.showFormPaiement = !this.showFormPaiement ;
                this.scrollToTop();
            },

            // Choisir un fichier png, jpg ou jpeg
            uploadPiece()
            {
                if ( this.$refs.piece.files[0].size > 10_000_000 )
                {
                    // File is to big > 10Mo
                    this.$swal({
                        title: 'Fichier volumineux !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Votre fichier dépasse la limite autorisée.</span>",
                    }); 

                    this.$refs.piece.value = null ;
                    return false;
                }

                this.formIdentification.piece = this.$refs.piece.files[0];
                // console.log(this.$refs.piece.files[0])
            },

            uploadPieceParent()
            {
                if ( this.$refs.pieceParent.files[0].size > 10_000_000 )
                {
                    // File is to big > 10Mo
                    this.$swal({
                        title: 'Fichier volumineux !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Votre fichier dépasse la limite autorisée.</span>",
                    }); 

                    this.$refs.pieceParent.value = null ;
                    return false;
                }

                this.formIdentification.pieceParent = this.$refs.pieceParent.files[0];
                // console.log(this.$refs.pieceParent.files[0])
            },

            listePays()
            {

                this.pays = [] ;
                this.options = [] ;

                for ( let j of flags ) {
                    this.pays.push(
                        {
                            country_code: j.flag +" +"+j.dial_code ,
                            country: j.name,//j.flag +" "+ j.name +" +"+ j.dial_code ,
                            code: j.dial_code ,
                            name: j.name,
                            alpha2: j.code
                        }
                    )

                    this.options.push(
                        {
                            country_code: j.flag +" +"+j.dial_code ,
                            country: j.flag +" "+ j.name +" +"+ j.dial_code ,
                            code: j.dial_code
                        }
                    )
                }


                // Indicatifs
                this.indiceTelephone.i = this.options.find( option => option.code === this.indiceTelephone.i );
                this.dataAPaym.indicatif = this.options.find( option => option.code === this.dataAPaym.indicatif );
                this.dataApaymPayAuth.indicatif = this.options.find( option => option.code === this.dataApaymPayAuth.indicatif );
                
                // Indicatif pour les mobile money ivoiriens
                this.indiceMobileMoney = this.options.find( option => option.code === "225" );

                // Indicatifs
                this.indice.i = this.pays.find( option => option.code === this.indice.i );
                // this.indiceMobileMoney = this.pays.find( option => option.code === "225" );
            },

            selectModePaiement(payment)
            {
                this.mode_paiement = payment ;
                this.scrollToTop();
                // this.showContent = !this.showContent ;
                // this.showMenu = !this.showMenu ;
            },

            validerModePaiement () 
            {

                if ( !this.refID )
                {
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Attention', 'Veuillez renseigner vos informations sur les formualires précédents');
                    return false;
                }
                
                // On affiche la page de succès
                if ( this.mode_paiement == "cash" )
                {

                    // On modifie le mode de paiement
                    let dataToSend = new FormData();
                    dataToSend.append("mode_paiement", "cash");
                    dataToSend.append("ref_id", this.refID);

                    axios.post(apiUrl + 'api/cartes/paiement-cash',
                        dataToSend
                    ).then(response => {

                        this.isLoading = false;
                        console.log(response);

                        if ( response.data["code"] == 1 )
                        {

                            this.hideRecu = false ;
                            this.showFormInformations = false ;
                            this.showFormIdentification = false;
                            this.showFormPaiement = false;
                            this.showContent = false;

                            this.logoOfSelectedService = "cash.png" ;

                            return false;
                        }

                        sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                    }).catch(error => {

                        this.isLoadingAPaym = false;
                        console.log(error);
                        sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', "Une erreur est survenue, veuillez réessayer plus tard");

                    });

                    return false;
                }

                this.showFormPaiement = false ;
                this.showContent = true ;
			},

            sendWave(option)
            { 
                this.isLoading = true ;
                let dataSend = new FormData();
                dataSend.append("ref_id", this.refID) ;
                dataSend.append("mode_paiement", "Wave") ;

                axios.post(apiUrl + 'api/cartes/paiement-wave',
                    dataSend
                ).then(response => {

                    this.isLoading = false ;
                    
                    if ( response.data.code == 1 ) {
                        if ( response.data.url == null || response.data.url == "" ) {

                            this.$refs['openWaveModal'].hide();
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Veuillez reprendre tout le processus, si le problème persiste, veuillez essayer un autre moyen de paiement svp.");
                            return false ;
                        }

                        if ( option == "app" ) {
                            window.location.href = response.data.url ;
                            return false;
                        }

                        // Open iframe in Modal
                        this.urlWave = response.data.url ;
                        // this.paiementNOkay = false ;
                        this.modalWave = true ;
                        this.$refs['openWaveModal'].show();

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoading = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            // Orange money payment
            sendOM(option) 
            { 
                // this.paiementNOkay = false ;
                this.isLoading = true ;
                let dataSend = new FormData();
                dataSend.append("ref_id", this.refID) ;
                dataSend.append("mode_paiement", "Orange Money") ;
                // dataSend.append("ref_id", window.localStorage.getItem("_reference_")) ;

                axios.post(apiUrl + 'api/cartes/paiement-orange',
                    dataSend
                ).then(response => {

                    this.isLoading = false ;
                    
                    if ( response.data.code == 1 ) {
                        
                        if ( response.data.url == null || response.data.url == "" ) {

                            this.$refs['openOrangeMoneyModal'].hide();
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Veuillez reprendre tout le processus, si le problème persiste, veuillez essayer un autre moyen de paiement svp.");

                            return false ;
                        }

                        if ( option == "app" ) {
                            window.location.href = response.data.url ;
                            return false;
                        }

                        if ( this.isMobile() ) {
                            window.location.href = "tel:%23 144*82 %23";
                        }

                        // Open iframe in Modal
                        this.urlOrange = response.data.url ;
                        // this.orangeOkay = true ;
                        // this.paiementNOkay = false ;
                        this.modalOrange = true ;
                        this.$refs['openOrangeMoneyModal'].show();

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoading = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            // MTN MoMo payment
            sendMoMo() 
            { 

                // this.mtnOkay = false ;
                this.paiementNOkay = false ;

                if (
                    this.dataMoMo.numero.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro MoMo !');
                    return false;
                }

                this.isLoading = true ;  
                let dataSend = new FormData();
                dataSend.append("ref_id", this.refID) ;
                dataSend.append("mode_paiement", "MTN Money") ;
                dataSend.append("numero_paiement", this.dataMoMo.numero.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/cartes/paiement-momo',
                    dataSend
                ).then(response => {

                    this.isLoading = false ; 

                    if ( response.data.code == 1000 ) {
                        
                        this.mtnOkay = true ;
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    this.mtnOkay = false ;

                }).catch(error => {

                    this.isLoading = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            // Moov money payment
            sendMoov() 
            { 
                this.moovOkay = false ;
                this.moovNOkay = false ;

                if (
                    this.dataMoov.numero.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro Flooz !');
                    return false;
                }

                this.moovOkay = true;

                let dataSend = new FormData();
                dataSend.append("ref_id", this.refID) ;
                dataSend.append("mode_paiement", "Moov Money") ;
                dataSend.append("numero_paiement", this.dataMoov.numero.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/cartes/paiement-moov',
                    dataSend
                ).then(response => {

                    if ( response.data.code == 1 ) {
                        
                        this.moovOkay = true ;
                        this.dataMoov.numero = "" ;
                        this.startTimer();

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]); // 
                    this.moovOkay = false ;

                }).catch(error => {

                    this.isLoadingFlooz = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            // Check if moov payment is made successfully or not
            checkingFloozStatus() 
            {

                let dataSend = new FormData();
                dataSend.append("ref_id", this.refID) ;

                axios.post(apiUrl + 'api/cartes/check-moov',
                    dataSend
                ).then(response => {

                    // Transaction was successfully
                    if ( response.data.statusCode == 0 ) {

                        clearInterval(this.stopInterval);
                        this.hideRecu = false ;
                        this.showFormInformations = false ;
                        this.showFormIdentification = false;
                        this.showFormPaiement = false;
                        this.showContent = false;
                        this.logoOfSelectedService = "flooz.png" ;

                    } else if ( response.data.statusCode == 47 ) {
                        
                        // Transaction is still pending
                        this.moovOkay = true ;
                        this.dataMoov.numero = "" ;
                        this.showVerifMoov = false ;
                        this.showInProcessMoov = true ;
                        this.checkMoovAgain();
                        return false ;

                    } else  {

                        // Transaction was failed
                        clearInterval(this.stopInterval);
                        this.moovNOkay = true ;
                        this.moovOkay = false;
                    }

                }).catch(error => {

                    this.moovOkay = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            checkMoovAgain()
            {
                // Vérification du statut de la transaction Flooz
                this.stopInterval = setInterval(() => {
                    this.checkingFloozStatus() ;
                }, 60000); // 60s => 1min
            },

            sendAPaym()
            {
                if (
                    this.dataAPaym.numero.replace(/\s/g, "") == "" ||
                    this.dataAPaym.codeApaym.replace(/\s/g, "") == ""  
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro de téléphone  ainsi que votre code de paiement !');
                    return false;
                }

                this.apaymNOkay = false ;
                this.isLoading = true;
                let dataSend = new FormData();
                dataSend.append("ref_id", this.refID) ;
                dataSend.append("mode_paiement", "APaym") ;
                dataSend.append("numAPaym", this.dataAPaym.indicatif.code +""+ this.dataAPaym.numero.replace(/\s/g, ""));
                dataSend.append("codePaiement", this.dataAPaym.codeApaym.replace(/\s/g, ""));

                // console.log(this.dataAPaym.indicatif.code +""+ this.dataAPaym.numero.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/cartes/paiement-apaym-code',
                    dataSend
                ).then(response => {

                    this.isLoading = false;

                    if ( response.data["codeMsg"] == 1 )
                    {

                        this.hideRecu = false ;
                        this.showFormInformations = false ;
                        this.showFormIdentification = false;
                        this.showFormPaiement = false;
                        this.showContent = false;
                        this.logoOfSelectedService = "apaym-ussd.png" ;

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    this.apaymNOkay = true ;

                }).catch(error => {

                    this.isLoading = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            // Bank card - BICICI Form
            sendBicici()
            {

                this.biciciNOkay = false ;
                this.isLoading = true ;

                let dataSend = new FormData();
                dataSend.append("ref_id", this.refID)
                dataSend.append("mode_paiement", this.mode_paiement);

                // api/cartes/paiement-bancaire
                axios.post(apiUrl + 'api/cartes/paiement-bancaire',
                    dataSend
                ).then(response => {

                    this.isLoading = false ;

                    if ( response.data.code == 1 ) {

                        if ( response.data.status == "INITIALIZED" ) {

                            this.contentBicici = response.data.redirect_url ;
                            this.modalBicici = true ;
                            this.$refs['openBiciciModal'].show();
                            return false;
                        }

                        sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                    return false;

                }).catch(error => {

                    this.isLoading = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });

            },

            // APaym authentication - Send connection code
            sendAPaymAuth()
            {

                if (
                    this.dataApaymPayAuth.numero.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro de téléphone APAYM !');
                    return false;
                }


                this.isLoading = true;
                this.hideCodePay = false ;

                let dataSend = new FormData();
                dataSend.append("numero", this.dataApaymPayAuth.indicatif.code +""+ this.dataApaymPayAuth.numero.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/cartes/authentification-apaym',
                    dataSend
                ).then(response => {

                    this.isLoading = false;

                    if ( response.data.code == 1 ) {

                        this.hideCodePay = true ;
                        this.dataApaymPayAuth.token = response.data.token ;
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoading = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });

            },

            // APaym authentication
            sendAPaymToken()
            {

                if (
                    this.dataApaymPayAuth.numero.replace(/\s/g, "") == "" ||
                    this.dataApaymPayAuth.code.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner numéro de téléphone APaym ainsi que votre code de connexion !');
                    return false;
                }

                this.isLoading = true;
                let dataSend = new FormData();
                dataSend.append("numero", this.dataApaymPayAuth.indicatif.code +""+ this.dataApaymPayAuth.numero.replace(/\s/g, ""));
                dataSend.append("codeConnexion", this.dataApaymPayAuth.code.replace(/\s/g, ""));
                dataSend.append("token", this.dataApaymPayAuth.token);

                axios.post(apiUrl + 'api/cartes/verifier-otp-apaym',
                    dataSend
                ).then(response => {

                    this.isLoading = false;

                    if ( response.data.code == 1 ) {

                        // Mask APaym auth form
                        this.loginApaym = false ;
                        this.hideCodePay = false ;

                        // Show list of cards
                        this.cards = [];
                        this.cardsLength = response.data["nombre_cards"];
                        this.showCard = true ;

                        for (let card of response.data["cards"]) {

                            if (card.card_key_name == "NSIACIVISAPCN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-01.png'
                                    }
                                )

                            } else if (card.card_key_name == "UBACIVISAPPB") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-06.png'
                                    }
                                )

                            } else if (card.card_key_name == "UBACIVISAPPN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-05.png'
                                    }
                                )

                            } else if (card.card_key_name == "UBACIVISAVCN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-Virtuelle-APAYM-UBA.png'
                                    }
                                )

                            } else {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'visa-autre.png'
                                    }
                                )

                            }

                        }

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                    this.showCard = false ;
                    this.hideCodePay = false ;
                    this.loginApaym = true ;
                    this.dataApaymPayAuth.code = "" ;
                    this.dataApaymPayAuth.token = "" ;

                }).catch(error => {

                    this.isLoadingAPaymAuth = false;
                    this.showCard = false ;
                    this.hideCodePay = false ;
                    this.loginApaym = true ;
                    this.dataApaymPayAuth.code = "" ;
                    this.dataApaymPayAuth.token = "" ;

                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });

            },

            // APaym payment with card from wallet
            payWithApaym(carte)
            {

                this.$swal({
                    title: "Paiement APAYM",
                    html: "<div style='line-height: 1.6;'>Votre carte "+ carte.nickname +" Visa **** <b>"+ carte.last_4_digit +"</b> sera débitée de <b>"+ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( this.montant ) +" F. CFA</b> pour valider le paiement.</div>",
                    icon: 'info',
                    showCancelButton: true,
                    cancelButtonColor: '#6e7881',
                    confirmButtonText:  "Oui, je confirme",
                    cancelButtonText: "Non",
                    reverseButtons: true
                }).then((result) => {

                    if (result.isConfirmed) {

                        this.apaymNOkay2 = false ;
                        this.isLoading = true;
                        let dataSend = new FormData();
                        dataSend.append("numero", this.dataApaymPayAuth.indicatif.code +""+ this.dataApaymPayAuth.numero.replace(/\s/g, "") );
                        dataSend.append("token", this.dataApaymPayAuth.token);
                        dataSend.append("reference", this.refID);
                        dataSend.append("card_id", carte.id);

                        axios.post(apiUrl + 'api/cartes/paiement-apaym-app',
                            dataSend
                        ).then(response => {

                            this.isLoading = false;
                            this.$swal.close() ;

                            if ( response.data.codeMsg == 1 ) {

                                this.dataApaymPayAuth.code = "" ;
                                this.dataApaymPayAuth.token = "" ;
                                this.hideRecu = false ;
                                this.showFormInformations = false ;
                                this.showFormIdentification = false;
                                this.showFormPaiement = false;
                                this.showContent = false;
                                this.logoOfSelectedService = "apaym.png" ;

                                return false;
                            }

                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                            this.showCard = false ;
                            this.hideCodePay = false ;
                            this.loginApaym = true ;
                            this.dataApaymPayAuth.code = "" ;
                            this.dataApaymPayAuth.token = "" ;
                            this.apaymNOkay2 = true ;

                        }).catch(error => {

                            this.isLoading = false;
                            console.log(error);
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                            this.showCard = false ;
                            this.hideCodePay = false ;
                            this.loginApaym = true ;
                            this.dataApaymPayAuth.code = "" ;
                            this.dataApaymPayAuth.token = "" ;

                        });

                    }
                });
            },

            // Disconnect APaym account
            disconnectApaym()
            {

                this.showCard = false ;
                this.hideCodePay = false ;
                this.loginApaym = true ;
                this.apaymNOkay2 = false ;

                this.dataApaymPayAuth.code = "" ;
                this.dataApaymPayAuth.token = "" ;
            },

            sendCardPaymentUba()
            {
                this.isLoading = true;
                window.location.href = apiUrl +"api/cartes/paiement-carte-bancaire/"+ this.refID ;
            },

            // isUnderage(event)
            // {
            //     this.formIdentification.mineur = event.target.checked ;
            //     // console.log(event.target.checked)
            // },

            printPdfRecu()
            {
                let data = Object.assign({}, this.$refs);
                data.document.removeAttribute("hidden");

                html2pdf(this.$refs.document, {
                    margin: 0.4,
                    filename: 'Reçu - '+this.refID+'.pdf',
                    image: { type: 'jpeg', quality: 1 },
                    html2canvas: { dpi: 192, letterRendering: true },
                    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                }) ;

                data.document.setAttribute("hidden", "");
            },

            // Is device a mobile device ?
            isMobile() 
            {
                var check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            },

            onTimesUp() 
            {
                clearInterval(this.timerInterval);
            },

            startTimer() 
            {
                this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
            },

            scrollToTop() {
                window.scrollTo(0,0);
            },

            validateEmail(email)
            {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                    return true ;
                } else {
                    return false ;
                }
            },

            validateString(string)
            {
                if (/^[A-Za-z- ]+$/.test(string)) {
                    return true ;
                } else {
                    return false ;
                }
            },

            validateSpecialString(string)
            {
                if (/^[a-zA-Z0-9- ]+$/.test(string)) {
                    return true ;
                } else {
                    return false ;
                }
            }
            
        },

        mounted() 
        {
            this.listePays() ;
            this.mobileDevice = this.isMobile() ;
            this.listeCartes.sort(function(a, b){ return a.montant - b.montant });

            // Update screen page with pusher 
            Pusher.logToConsole = false;
            var channel = this.$pusher.subscribe('wby-reload');
            var my = this ;
            var session = sessionStorage ;
            var response = function(data) {

                session.clear() ;

                if ( data.type == "MTN Money" ) 
                {

                    if ( 
                        data.status == "success" && data.reference == window.localStorage.getItem("_reference_") && my.montant
                    ) 
                    {

                        my.hideRecu = false ;
                        my.showFormInformations = false ;
                        my.showFormIdentification = false;
                        my.showFormPaiement = false;
                        my.showContent = false;

                        my.logoOfSelectedService = "momo.png" ;

                    } else if ( 
                        ( data.responseCode == "529" || data.responseCode == "515" || data.responseCode == "9" || data.responseCode == "100" )  
                        && data.reference == window.localStorage.getItem("_reference_") && my.montant
                    ) 
                    {

                        my.mtnNOkay = true ;
                        my.mtnOkay = false ;
                    }

                } else if ( data.type == "Orange Money" ) 
                {

                    if ( 
                        data.status == "success" && data.reference == window.localStorage.getItem("_reference_") && my.montant
                    ) 
                    {
                        
                        my.hideRecu = false ;
                        my.modalOrange == true ? my.$refs['openOrangeMoneyModal'].hide() : "" ;
                        my.showFormInformations = false ;
                        my.showFormIdentification = false;
                        my.showFormPaiement = false;
                        my.showContent = false;

                        my.logoOfSelectedService = "om.png" ;

                    } else if ( 
                        data.responseCode !== "SUCCESS" && data.reference == window.localStorage.getItem("_reference_")  && my.montant
                    ) 
                    {

                        my.orangeNOkay = true ;
                        my.modalOrange == true ? my.$refs['openOrangeMoneyModal'].hide() : "" ;

                    }

                } else if ( data.type == "Wave" ) 
                {

                    if ( 
                        data.status == "success" && data.reference == window.localStorage.getItem("_reference_") && my.montant
                    ) 
                    {
            
                        my.hideRecu = false ;
                        my.modalWave == true ? my.$refs['openWaveModal'].hide() : "" ;
                        my.showFormInformations = false ;
                        my.showFormIdentification = false;
                        my.showFormPaiement = false;
                        my.showContent = false;

                        my.logoOfSelectedService = "wave.png" ;

                    } else if ( 
                        data.responseCode !== "SUCCESS" && 
                        data.reference == window.localStorage.getItem("_reference_") && my.montant
                    ) 
                    {

                        my.waveNOkay = true ;
                        my.modalWave == true ? my.$refs['openWaveModal'].hide() : "" ;

                    }

                } else if ( data.type == "BICICI" ) {

                    if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_") && my.montant ) {

                        my.hideRecu = false ;
                        my.modalBicici == true ? my.$refs['openBiciciModal'].hide() : "" ;
                        my.showFormInformations = false ;
                        my.showFormIdentification = false;
                        my.showFormPaiement = false;
                        my.showContent = false;

                        my.logoOfSelectedService = my.mode_paiement == "VISA" ? "visa.png" : "mastercard.png" ;

                    } else if ( data.responseCode !== "BICICI-SUCCESS" && data.reference == window.localStorage.getItem("_reference_") && my.montant ) {

                        my.biciciNOkay = true;
                        my.modalBicici == true ? my.$refs['openBiciciModal'].hide() : "";
                    }
                }
            };

            // Écouteur sur les mises à jour des paiements pour checker le statut
            channel.bind('pay-card', response);
        },
        watch: {
            timeLeft(newValue) {
                if (newValue === 0) {
                    this.onTimesUp();
                    this.showVerifMoov = true ;
                    this.checkingFloozStatus() ;
                }
            },

        },
        created() {
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    table { width:100%; }
    .intitule { font-weight:normal; color:#333;}

    .pos-relative{
        position: relative;
    }

    .pos-relative .line {
        position: relative;
        padding-top: 20px;
    }
    
    .pos-relative .line:after {
        content: "";
        position: relative;
        left: 40%;
        width: 20%;
        height: 2px;
        background: #faaa13;
        top: -115px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
    }

    .pos-relative2{
        position: relative;
    }

    .pos-relative2 .line2 {
        position: relative;
        padding-top: 50px;
    }

    .pos-relative2 .line2:after {
        content: "";
        position: absolute;
        left: 40%;
        width: 20%;
        height: 4px;
        background: #dfe2e5;
        top: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        /*border-radius: 20px;*/
    }

    .floating-container {
        position: fixed;
        width: auto;
        /* height: 100px; */
        bottom: 40px;
        right: 0;
        margin: 30px 25px;
        z-index: 20;
    }

    .custom-shadow{
        box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px !important;
    }

    .content {
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: auto;
        overflow: hidden;
    }

    .custom-rounded {
        border-radius: 32px;
    }

    .shadow{
        box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;
        border-radius: 20px;
    }

    .menu-cabine {
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
    }

    .menu-cabine:hover, .menu-cabine:focus{
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
        /* border-radius: 5px; */
        /* box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px; */
    }

    /*.content .content-overlay {*/
    /*    background: rgba(0,0,0,0.7);*/
    /*    position: absolute;*/
    /*    height: 100%;*/
    /*    width: 100%;*/
    /*    left: 0;*/
    /*    top: 0;*/
    /*    bottom: 0;*/
    /*    right: 0;*/
    /*    opacity: 0;*/
    /*    -webkit-transition: all 0.5s ease-in-out 0s;*/
    /*    -moz-transition: all 0.5s ease-in-out 0s;*/
    /*    transition: all 0.5s ease-in-out 0s;*/
    /*    border-radius: 14px;*/
    /*}*/

    /*.content:hover .content-overlay{*/
    /*    opacity: 1;*/
    /*}*/



    .content-overlay:hover{
        transition: all 0.3s;
        border-color: #faaa13;
        border-style: solid;
        border-width: 2px;
        /*padding: 8px;*/
        border-radius: 25px;
        /*box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;*/
    }

    .content-image{
        width: 100%;
    }

    .content:hover .content-details{
        top: 50%;
        left: 50%;
        opacity: 1;
    }

    .content-details {
        position: absolute;
        text-align: center;
        padding-left: 1em;
        padding-right: 1em;
        width: 100%;
        top: 50%;
        left: 50%;
        opacity: 0;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        -webkit-transition: all 0.3s ease-in-out 0s;
        -moz-transition: all 0.3s ease-in-out 0s;
        transition: all 0.3s ease-in-out 0s;
    }

    .fadeIn-top{
        top: 20%;
    }

    .content-details h3{
        color: #fff;
        font-weight: 500;
        letter-spacing: 0.15em;
        margin-bottom: 0.5em;
        text-transform: uppercase;
    }

    .content-details p{
        color: #fff;
        font-size: 0.8em;
    }

    .show-selected-mode{
        position: absolute;
        /*right: 3px;*/
        /*top: -6px;*/
        right: 17px;
        top: 18px;
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .show-selected-mode2{
        position: absolute;
        right: 3px;
        top: -9px;
        /*right: 20px;*/
        /*top: 8px;*/
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .btn-disabled-custom {
        background: rgb(0 0 0 / 8%);
        border: rgb(0 0 0 / 8%);
        color: #1b1e21;
        cursor: not-allowed;
    }

    .mode-rechargement {
        display: flex;
        flex-direction: column;
        cursor: pointer;
    } 

    @media (max-width: 767px) {
        .content {
            width: 80%;
        }
        .show-selected-mode{
            right: 44px;
        }
    }

    .searchIcon {
        margin-left: -35px;
        cursor: pointer;
        /* color: #261b64; */
        color: #343a40;
        cursor: pointer;
        font-size: 25px;
        z-index: 50;
    }

    .btn-close-modal {
        position: absolute;
        font-size: 23px;
        color: #1b1e21;
        top: -4px;
        cursor: pointer;
        font-weight: 700;
        left: 102%;
        height: 25px;
        width: 25px;
    }

    .btn-close-modal-small {
        position: absolute;
        color: #1b1e21;
        top: 0;
        cursor: pointer;
        font-weight: 700;
        right: 0;
        /* height: 25px; */
        width: 25px;
        z-index: 50;
    }

    .text-modal-small {
        position: relative;
        color: #1b1e21;
        top: 5px;
        font-size: 16px;
        display: flex;
        justify-content: center;
        white-space: break-spaces;
        align-items: baseline;
    }

</style>
